const config = {
    env: process.env.HOST == 'prod',
    isSupportListConfig: false,
    version: '2.3.2',
    isUpdateCache : true,
}
const model = {

    login: { //编号登录
        url: 'ums/auth/login',
        method: 'post',
    },

    getCode: { // 获取验证码
        url: 'ums/getCode',
        method: 'post',
    },

    msgLogin: { // 短信登录
        url: 'getCode',
        method: 'post',
    },

    loginOut: { //退出登录
        url: 'ums/auth/login',
        method: 'post',
    },

    changeJob: { //切换岗位
        url: 'ums/changeJob',
        method: 'post',
    },

    getMultipleConfig: { //批量获取元数据信息
        url: 'pub/common/getMultipleConfig',
        method: 'post',
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 菜单 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getMenuList: { //获取全部菜单列表
        url: 'ums/permissionModule',
        method: 'get',
    },

    setMenuList: { //创建新的菜单信息
        url: 'ums/permissionModule',
        method: 'post',
    },

    getMenuInfo: { //获取菜单详细信息
        url: 'ums/permissionModule',
        method: 'get',
    },

    updateMenuInfo: { //更新菜单详细信息
        url: 'ums/permissionModule',
        method: 'put',
    },

    setOperation: { //添加新的操作
        url: 'ums/permissionPackage',
        method: 'post',
    },

    getOperation: { //获取操作列表
        url: 'ums/permissionPackage',
        method: 'get',
    },

    updateOperation: { //修改操作
        url: 'ums/permissionPackage',
        method: 'put',
    },

    updateOperationStatus: { //修改操作
        url: 'ums/permissionModule/setStatus',
        method: 'get',
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 岗位 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getWorkerPosition: { // 获取id为空岗位信息
        url: 'ums/workerPosition',
        method: 'get'
    },
    getWorkerPositionMarket: { // 获取对应员工的职位信息
        url: 'ums/workerPosition/getWorkerPosition',
        method: 'get'
    },

    setUserPosition: {
        url: 'ums/workerPosition',
        method: 'post'
    },

    editUserPosition: {
        url: 'ums/workerPosition',
        method: 'put'
    },

    delUserPosition: {
        url: 'ums/workerPosition',
        method: 'delete'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 角色 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getRoleManageDashboards: { // 获取角色看板权限工作台列表
        url: 'ums/roleManage/dashboards/config',
        method: 'get'

    },
    getFinalDashboards: { // 获取最终看板显示模块
        url: 'ums/roleManage/dashboards/chosen',
        method: 'get'
    },
    putRoleManageDashboards: { //更新角色看板权限工作台列表
        url: 'ums/roleManage/dashboards/config',
        method: 'put',

    },
    getRoleList: { //角色列表
        url: 'ums/roleManage',
        method: 'get',
    },

    setRole: { //添加角色
        url: 'ums/roleManage',
        method: 'post',
    },

    updateRole: { //修改角色
        url: 'ums/roleManage',
        method: 'put',
    },

    setStatus: { //设置角色状态
        url: 'ums/roleManage/setStatus',
        method: 'post',
    },

    getJob: { // 获取角色及其相关职位信息
        url: 'ums/roleManage/job',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 职位 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getPositionList: { //获取职位列表
        url: 'ums/position',
        method: 'get',
    },

    addPosition: { //add职位
        url: 'ums/position',
        method: 'post',
    },

    editPosition: { //add职位
        url: 'ums/position',
        method: 'put',
    },

    getPositionInfo: { // 获取详情
        url: 'ums/position',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 员工管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getEmployeeList: { // 员工列表
        url: 'ums/workers',
        method: 'get'
    },

    addEmployee: { // 添加员工
        url: 'ums/workers',
        method: 'post'
    },

    editEmployee: { // 修改员工
        url: 'ums/workers',
        method: 'put'
    },

    getEmployeeInfo: { // 获取员工信息
        url: 'ums/workers',
        method: 'get'
    },

    editEmployeeStatus: { // 状态变更
        url: 'ums/workers/setStatus',
        method: 'post'
    },

    deleteEmployee: { // 删除员工
        url: 'ums/workers',
        method: 'delete'
    },

    getUserInfo: { //获取用户信息
        url: 'ums/person/getUser',
        method: 'get',
    },

    resetPassword: { // 重置密码
        url: 'ums/person/resetPwd',
        method: 'get'
    },

    updatePassword: {
        url: 'ums/person/editPwd',
        method: 'post'
    },

    getEmployeeDept: { // 获取部门下所有员工
        url: 'ums/workers/getDepWorkers',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 常量 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    setConstantGroup: { //添加常量组
        url: 'pub/configItem',
        method: 'post',
    },

    updateConstantGroup: { //修改常量组
        url: 'pub/configItem',
        method: 'put',
    },

    getConstantGroupList: { //获取常量组列表
        url: 'pub/configItem',
        method: 'get',
    },

    getConstantGroupMess: { //获取长两组的详细信息
        url: 'pub/configItem',
        method: 'get',
    },

    setConstant: { //添加常量
        url: 'pub/configValue',
        method: 'post',
    },

    updateConstant: { //修改常量
        url: 'pub/configValue',
        method: 'put',
    },

    deleteConstant: { //删除常量
        url: 'pub/configValue',
        method: 'delete',
    },

    getConstantList: { //获取常量列表
        url: 'pub/configValue',
        method: 'get',
    },

    getBatchConstantList: { //批量获取常量列表
        url: 'pub/configItem/getConfigItemByConfigKey',
        method: 'get',
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 组织架构 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getDepartment: { //获取组织架构
        url: 'pub/department',
        method: 'get',
    },

    setDepartment: { //添加组织架构
        url: 'pub/department',
        method: 'post',
    },

    getDepartmentMess: { //获取组织信息
        url: 'pub/department',
        method: 'get',
    },

    updateDepartment: { //更新组织架构信息
        url: 'pub/department',
        method: 'put',
    },

    deleteDepartment: { //删除组织架构
        url: 'pub/department',
        method: 'delete',
    },

    departmentSetupDepartment: { //设置机构配置参数
        url: 'pub/department/setupDepartment',
        method: 'post',
    },

    getDownDepartment: { // 获取下级部门
        url: 'pub/department/downDepartment',
        method: 'get'
    },

    getMultipleConfigService: {
        url: 'pub/common/getMultipleConfigService',
        method: 'post'
    },

    setMemberShipCardValue: {
        url: 'pub/department/setMemberShipCardValue',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 获取结构的短信配置 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getDepSmsDeploy: { //获取机构的短信配置的信息
        url: 'pub/department/depSmsDeploy',
        method: 'get',
    },
    updateDepSmsDeploy: {//更新机构的短信配置的信息
        url: 'pub/department/depSmsDeployUp',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 年级 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getGradeList: { //获取年级列表
        url: 'pub/grade',
        method: 'get',
    },

    getBranch: { //获取分公司列表
        url: 'pub/department/branchAndSchool',
        method: 'get',
    },

    addGrade: { //年级添加
        url: 'pub/grade',
        method: 'post',
    },

    editGrade: { //修改年级
        url: 'pub/grade',
        method: 'put',
    },

    deleteGrade: { //修改年级
        url: 'pub/grade',
        method: 'delete',
    },

    getItsGradeList: { //获取ITS年级信息
        url: 'pub/grade/getItsGradeList',
        method: 'get',
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 产品类型 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getProList: { //获取产品列表
        url: 'pub/productType',
        method: 'get',
    },

    addPro: { //产品add
        url: 'pub/productType',
        method: 'post',
    },

    detailPro: { //产品detail
        url: 'pub/productType',
        method: 'get',
    },

    editPro: { //修改产品
        url: 'pub/productType',
        method: 'put',
    },

    delPro: { //删除产品类型
        url: 'pub/productType/status',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 校区 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getSchoolList: { //获取校区列表
        url: 'pub/school',
        method: 'get',
    },

    addSchool: { //校区添加
        url: 'pub/school',
        method: 'post',
    },

    editSchool: { //修改校区
        url: 'pub/school',
        method: 'put',
    },

    delSchool: { //删除校区
        url: 'pub/school',
        method: 'delete'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 渠道 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getSourceList: { //获取渠道列表
        url: 'pub/channel',
        method: 'get',
    },

    getSourceInfo: { //获取渠道详情
        url: 'pub/channel',
        method: 'get',
    },

    addSource: { //添加渠道
        url: 'pub/channel',
        method: 'post',
    },

    editSource: { //修改渠道
        url: 'pub/channel',
        method: 'put',
    },

    delSource: { //删除渠道
        url: 'pub/channel',
        method: 'delete'
    },

    getOneType: { // 获取某一类渠道
        url: 'pub/channel/channelByType',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 协议模板 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getContractTemplateList: { // 获取协议模板列表
        url: 'pub/contractTemplate',
        method: 'get'
    },

    setContractTemplate: { // 添加协议模板
        url: 'pub/contractTemplate',
        method: 'post'
    },

    editContractTemplate: { // 修改协议模板
        url: 'pub/contractTemplate',
        method: 'put'
    },

    detailContractTemplate: { // 协议模板详情
        url: 'pub/contractTemplate',
        method: 'get'
    },

    stopContractTemplate: { // 修改协议模板状态
        url: 'pub/contractTemplate/setStatus',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 元数据看板 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    addDashboards: { // 添加看板元数据
        url: 'pub/dashboards',
        method: 'post'
    },
    ListDashboards: { // 列表看板元数据
        url: 'pub/dashboards',
        method: 'get'
    },
    editDashboards: { // 编辑看板元数据
        url: 'pub/dashboards',
        method: 'put'
    },
    enableDashboards: { // 启用看板元数据
        url: 'pub/dashboards/enable',
        method: 'put'
    },
    disableDashboards: { // 禁用看板元数据
        url: 'pub/dashboards/disable',
        method: 'put'
    },



    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 印章 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getStampManageList: { // 获取印章列表
        url: 'pub/stampManage',
        method: 'get'
    },

    setStampManage: { // 添加印章
        url: 'pub/stampManage',
        method: 'post'
    },

    editStampManage: { // 修改印章
        url: 'pub/stampManage',
        method: 'put'
    },

    stopStampManage: { // 修改印章状态
        url: 'pub/stampManage/setStatus',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 短信 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getMsgList: {
        url: 'pub/smsLog/index',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 问题反馈 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getQuestionList: {
        url: 'pub/problemFeedback/index',
        method: 'get'
    },

    setQuestion: {
        url: 'pub/problemFeedback/store',
        method: 'post'
    },

    replyQuestion: {
        url: 'pub/problemFeedback/reply',
        method: 'post'
    },

    delQuestion: {
        url: 'pub/problemFeedback/destroy',
        method: 'delete'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> APP管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    appVersionList: { // 列表
        url: 'pub/appVersion',
        method: 'get'
    },

    appVersionInfo: { // 获取详情
        url: 'pub/appVersion',
        method: 'get'
    },

    appVersionAdd: { // 添加
        url: 'pub/appVersion',
        method: 'post'
    },

    appVersionUpdate: { // 更新
        url: 'pub/appVersion',
        method: 'put'
    },

    appVersionDelete: { // 删除
        url: 'pub/appVersion',
        method: 'delete'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 学科管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getSubjectList: { // 列表
        url: 'pub/subject',
        method: 'get'
    },

    createSubject: { // 添加
        url: 'pub/subject',
        method: 'post'
    },

    getSubjectDetail: { // 详情
        url: 'pub/subject',
        method: 'get'
    },

    updateSubject: { // 修改
        url: 'pub/subject',
        method: 'put'
    },

    statuSubject: { // 启停
        url: 'pub/subject',
        method: 'delete'
    },

    ajaxSubject: { // 下拉
        url: 'pub/subject/ajaxSubject',
        method: 'get'
    },

    getItsSubjectList: { // 获取ITS科目列表
        url: 'pub/subject/getItsSubjectList',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 档期管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getScheduleList: { // 列表
        url: 'pub/theaterSchedule',
        method: 'get'
    },

    createSchedule: { // 添加
        url: 'pub/theaterSchedule',
        method: 'post'
    },

    getScheduleDetail: { // 详情
        url: 'pub/theaterSchedule',
        method: 'get'
    },

    updateSchedule: { // 修改
        url: 'pub/theaterSchedule',
        method: 'put'
    },
    updateScheduleLastList: { // 获取上个档期
        url: 'pub/theaterSchedule/lastList',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 班型管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getClassTypeList: { // 列表
        url: 'pub/classType',
        method: 'get'
    },

    normalClassTypeList: { // 正常列表
        url: 'pub/classType/classTypeList',
        method: 'get'
    },

    createClassType: { // 添加
        url: 'pub/classType',
        method: 'post'
    },

    getClassTypeDetail: { // 详情
        url: 'pub/classType',
        method: 'get'
    },

    updateClassType: { // 修改状态
        url: 'pub/classType/status',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 个人中心 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    uploadImg: {
        url: 'pub/common/upload',
        method: 'post'
    },

    submitAvatar: {
        url: 'ums/person/uploadAvatar',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 客户中心 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getUserFollowList: { //跟进用户列表
        url: 'crm/userFollow/getUserFollowList',
        method: 'get'
    },

    getFollowUserInfo: { //渠道用户信息
        url: 'crm/userFollow/getFollowUserInfo',
        method: 'post'
    },

    getFollowList: { //某用户跟进记录
        url: 'crm/userFollow/getFollowList',
        method: 'get'
    },

    a: { //签约客户
        url: 'crm/userFollow/a',
        method: 'get'
    },

    getSigningPlan: { //签约计划
        url: 'crm/signingPlan',
        method: 'get'
    },

    setSigningPlan: { //添加签约计划
        url: 'crm/signingPlan',
        method: 'post'
    },

    updateSigningPlan: { //修改签约计划
        url: 'crm/signingPlan',
        method: 'put'
    },

    c: { //到访客户
        url: 'crm/userFollow/c',
        method: 'get'
    },

    getVisit: { //到访计划
        url: 'crm/visit',
        method: 'get'
    },

    setVisit: { //添加到访计划
        url: 'crm/visit',
        method: 'post'
    },

    updateVisit: { //修改到访计划
        url: 'crm/visit',
        method: 'put'
    },

    getReturnVisit: { //客户回访
        url: 'crm/returnVisit',
        method: 'get'
    },

    setReturnVisit: { //添加客户回访
        url: 'crm/returnVisit',
        method: 'post'
    },

    updateReturnVisit: { //修改客户回访
        url: 'crm/returnVisit',
        method: 'put'
    },

    getInterview: { //约访计划
        url: 'crm/interview',
        method: 'get'
    },

    setInterview: { //添加约访计划
        url: 'crm/interview',
        method: 'post'
    },

    updateInterview: { //修改约访计划
        url: 'crm/interview',
        method: 'put'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 渠道资源池 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getCustomerBymobile: { //根据mobile获取客户信息
        url: 'crm/customer/customerInfo',
        method: 'get'
    },

    getCustomerById: { //根据id获取客户信息
        url: 'crm/customer',
        method: 'get'
    },

    getChannelCustomer: { //渠道客户资源池
        url: 'crm/customerChannel',
        method: 'get'
    },

    createChannelCustomer: { //渠道客户资源添加
        url: 'crm/customerChannel',
        method: 'post'
    },

    editChannelCustomer: { //渠道客户资源修改
        url: 'crm/customerChannel',
        method: 'put'
    },

    getCustomerChannelInfo: { //获取渠道ID的资源客户信息
        url: 'crm/customerChannel',
        method: 'get'
    },

    assortCustomerSchool: { // 分配校区
        url: 'crm/customerSchool/assignment',
        method: 'post'
    },

    moveCustomer: { // 客户转移
        url: 'crm/customerChannel/transfer',
        method: 'post'
    },

    completeName: { // 补充学生姓名
        url: 'crm/customer/editCustomerName',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 校区资源池 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    customerAllocationRole1: { // 分配咨询师
        url: 'crm/customerAssign/assignment',
        method: 'post'
    },

    customerAllocationRole2: { // 分配学管师
        url: 'crm/customerAssign/assignmentAdmin',
        method: 'post'
    },

    customerAllocationRole3: { // 分配班组客服
        url: 'crm/customerAssign/assignmentService',
        method: 'post'
    },

    customerAllocationRole4: { // 覆盖咨询师(咨询主任)
        url: 'crm/customerAssign/replaceButtPerson',
        method: 'post'
    },

    customerAllocationRole5: { // 覆盖学管师(咨询主任)
        url: 'crm/customerAssign/replaceAdmin',
        method: 'post'
    },

    customerAllocationRole6: { // 覆盖班组客服(咨询主任)
        url: 'crm/customerAssign/replaceService',
        method: 'post'
    },

    claimCustomer: { // 认领客户
        url: 'crm/customerAssign/claim',
        method: 'post'
    },

    freedCustomer: { // 释放客户
        url: 'crm/customerAssign/release',
        method: 'post'
    },

    getSchoolCustomer: { // 校区资源池列表
        url: 'crm/customerSchool',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 上门管理 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getSchoolCustomerByMoobile: { // 查询
        url: 'crm/customerSchool/customerChannelBySchoolID',
        method: 'get'
    },

    createVisitCustomer: { // 上门录入
        url: 'crm/visit/customerToDoorRegistration',
        method: 'post'
    },

    createVisitCustomerOnce: { // 上门录入一次提交
        url: 'crm/visit/userVisitRegister',
        method: 'post'
    },

    getCustomerToDoorInfo: { // 获取预约信息
        url: 'crm/visit/getCustomerToDoorInfo',
        method: 'get'
    },

    visitCustomerList: {
        url: 'crm/visit/getCustomerVisit',
        method: 'get'
    },

    visitCustomerregist: {
        url: 'crm/visit/customerVisitRegister',
        method: 'get'
    },

    editCustomer: { // 上门登记修改
        url: 'crm/customer',
        method: 'put'
    },

    getCustomerdetail: { // 获取客户信息
        url: 'crm/customer',
        method: 'get'
    },

    batchConfirmVisit: {
        url: 'crm/visit/customerBatchToDoorConfirmation',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 渠道覆盖提醒 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    coverRemindList: {
        url: 'crm/customerSchool/channelCoverList',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 转介绍 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    IntroductionList: {
        url: 'crm/customerIntroduction',
        method: 'get'
    },

    addIntroduction: {
        url: 'crm/customerIntroduction',
        method: 'post'
    },

    checkUserById: {
        url: 'boss/bossCommon/getUserById',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 定金相关 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    creatDeposit: {
        url: 'crm/customerDeposit',
        method: 'post'
    },

    depositList: {
        url: 'crm/customerDeposit',
        method: 'get'
    },

    depositDetail: {
        url: 'crm/customerDeposit',
        method: 'get'
    },

    depositStatus: {
        url: 'crm/customerDeposit',
        method: 'put'
    },

    depositStatistics: {
        url: 'crm/customerDeposit/totalStatis',
        method: 'post'
    },

    depositTotal: {
        url: 'crm/customerDeposit/getCustomerDepositTotal',
        method: 'get'
    },
    depositRefund: { // 定金退款申请
        url: 'crm/customerDeposit/depositRefund',
        method: 'post'
    },
    refundCancel: { // 定金退款取消
        url: 'crm/customerDeposit/cancelRefund',
        method: 'post'
    },
    refundConfirm: { // 定金退款确认
        url: 'crm/customerDeposit/setStatus',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 部门排班计划 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    schedulePlanList: { //部门排班列表
        url: 'crm/customerSchedulePlan',
        method: 'get'
    },
    addSchedulePlan: { //新增部门排班
        url: 'crm/customerSchedulePlan',
        method: 'post'
    },
    updateSchedulePlan: { //修改部门排班
        url: 'crm/customerSchedulePlan',
        method: 'put'
    },
    getScheduleInfo: { //获取排班详情
        url: 'crm/customerSchedulePlan',
        method: 'get'
    },
    invalidSchedulePlan: { // 作废排班
        url: 'crm/customerSchedulePlan/invalidSchedulePlan',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 资源中心对接列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    connectedList: { //资源对接记录
        url: 'crm/customerToConnected',
        method: 'get'
    },
    connectedAssortSchool: { //资源对接校区
        url: 'crm/customerToConnected/assignment',
        method: 'post'
    },  
    connectedAssortJson: { //资源批量对接校区
        url: 'crm/customerToConnected/assignmentJson',
        method: 'post'
    },
    moveAssortCustomer: { //资源批量分配
        url: 'crm/customerToConnected/moveAssortCustomer',
        method: 'post'
    },
    connectedUpdChannelCrmType: { //更新渠道crm等级
        url: 'crm/customerToConnected/updChannelCrmType',
        method: 'post'
    }, 
    connectedUpdChannelCrmPublic: { //更新渠道crm公共资源
        url: 'crm/customerToConnected/updChannelPublicResource',
        method: 'post'
    },
    connectedUpdNnullifyStatus: { //更新渠道crm作废状态
        url: 'crm/customerToConnected/updConnectedNullifyStatus',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 学生中心 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getStudentList: { //学生列表
        url: 'boss/student',
        method: 'get'
    },
    getStudentGraduateList: { //结业学生列表
        url: 'boss/student/endClassStudent',
        method: 'get'
    },

    addStudent: {
        url: 'boss/student',
        method: 'post'
    },

    updateStudent: {
        url: 'boss/student',
        method: 'put'
    },

    updateStudentStatus: {
        url: 'boss/student',
        method: 'delete'
    },

    getStudentInfo: {
        url: 'boss/student',
        method: 'get'
    },
    getStudentPersonId: {
        url: 'boss/student/getStudent',
        method: 'get'
    },

    freedConsultantStudent: { // 释放咨询
        url: 'boss/studentSchools/release',
        method: 'post'
    },

    allocationRole1: { // 分配咨询师
        url: 'boss/studentSchools/assignment',
        method: 'post'
    },

    allocationRole3: { // 分配班组客服
        url: 'boss/studentSchools/assignmentService',
        method: 'post'
    },

    allocationRole2: { // 分配学管师
        url: 'boss/studentSchools/assignmentAdmin',
        method: 'post'
    },

    allocationRole4: { // 覆盖咨询师(咨询主任)
        url: 'boss/studentSchools/replaceButtPerson',
        method: 'post'
    },

    allocationRole6: { // 覆盖班组客服(咨询主任)
        url: 'boss/studentSchools/replaceService',
        method: 'post'
    },


    allocationRole5: { // 覆盖学管师(咨询主任)
        url: 'boss/studentSchools/replaceAdmin',
        method: 'post'
    },

    checkITS: { // 查询its
        url: 'boss/student/searchITS',
        method: 'post'
    },

    bindITS: {
        url: 'boss/student/bindingITS',
        method: 'post'
    },
    editBindingITS: {
        url: 'boss/student/editBindingITS',
        method: 'post'
    },

    depositOffset: { // 定金冲抵
        url: 'boss/rechargeOrder/depositOffset',
        method: 'post'
    },

    createOrder: { // 创建订单
        url: 'boss/rechargeOrder',
        method: 'post'
    },

    orderDetail: { // 订单详情
        url: 'boss/rechargeOrder',
        method: 'get'
    },

    orderRebateList: { // 充值订单返利列表
        url: 'boss/rechargeOrderRebate',
        method: 'get'
    },
    orderRebateDetail: { // 充值订单返利详情
        url: 'boss/rechargeOrderRebate',
        method: 'get'
    },
    orderRebateExport: { // 充值订单导出
        url: 'boss/rechargeOrderRebate/export',
        method: 'get'
    },
    updateOrderRebate: { // 充值订单返利保存
        url: 'boss/rechargeOrderRebate',
        method: 'post'
    },
    confirmRebateOrder: { // 充值订单返利确认
        url: 'boss/rechargeOrderRebate/confirmRebateOrder',
        method: 'post'
    },
    invalidateRebateOrder: { // 充值订单返利作废
        url: 'boss/rechargeOrderRebate/invalidateRebateOrder',
        method: 'post'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 学生中心--产品 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    productionList: { // 产品列表
        url: 'boss/product',
        method: 'get'
    },

    productionCreate: { // 产品add
        url: 'boss/product',
        method: 'post'
    },

    productionDetail: { // 产品detail
        url: 'boss/product',
        method: 'get'
    },

    productionUpdate: { // 产品update
        url: 'boss/product',
        method: 'put'
    },

    productionEnable: { // 产品enable
        url: 'boss/product/enable',
        method: 'post'
    },

    productionDisable: { // 产品disable
        url: 'boss/product/disable',
        method: 'post'
    },

    productionActivityType: { // 创建活动时可选的适用产品列表
        url: 'boss/product/getListByActivityType',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 学生中心--产品购买记录 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    productOrderCreate: { // 购买产品
        url: 'boss/productOrder',
        method: 'post'
    },

    productOrderList: { // 购买记录列表
        url: 'boss/productOrder',
        method: 'get'
    },

    productOrderDetail: { // 购买产品detail
        url: 'boss/productOrder',
        method: 'get'
    },
    paymentRecordIndex: { // 产品订单所有充值单支付详情列表
        url: 'boss/productOrder/paymentRecordIndex',
        method: 'get'
    },

    productOrderCalculation: { // 购买产品price
        url: 'boss/productOrder/calculation',
        method: 'post'
    },

    getProductByOrder: { // 根据类型 年级查产品
        url: 'boss/product/getProductByOrder',
        method: 'get'
    },

    getProductByNumber: { // 创建班级时可购买产品的列表
        url: 'boss/product/getListByPersonNumber',
        method: 'get'
    },

    getDepConfigure: {
        url: 'pub/department/getDepConfigure',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 活动 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getActivity: { //活动列表
        url: 'pub/activity',
        method: 'get'
    },

    detailActivity: { //活动detail
        url: 'pub/activity',
        method: 'get'
    },

    setActivity: { //添加活动
        url: 'pub/activity',
        method: 'post'
    },

    editActivity: { //修改活动
        url: 'pub/activity',
        method: 'put'
    },

    stopActivity: { //停用活动
        url: 'pub/activity/close',
        method: 'post'
    },

    statusActivity: { //设置活动状态
        url: 'pub/activity/status',
        method: 'post'
    },

    activityByProduct: { // 获取某产品适用的活动列表
        url: 'pub/activity/listByProductId',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 财务中心 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    orderLIst: { // 订单列表
        url: 'boss/rechargeOrder',
        method: 'get'
    },

    branchOrderPdfSendMail: { // 订单的pdf发送邮件
        url: 'boss/rechargeOrder/rechargeOrderPDFSendMail',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 教务中心 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    createClass: { // 创建班级
        url: 'boss/classTeam',
        method: 'post'
    },

    getClassDetail: { // 班级detail
        url: 'boss/classTeam',
        method: 'get'
    },

    updateClassTeacher: { // 班级老师update
        url: 'boss/classTeam',
        method: 'put'
    },

    updateClassStudent: { // 班级学生update
        url: 'boss/classTeam/students',
        method: 'put'
    },

    deleteClassStudent: { // 班级学生delete
        url: 'boss/classTeam/students',
        method: 'delete'
    },

    checkClass: { // 班级可编辑
        url: 'boss/classTeam/isClassTeamChange',
        method: 'get'
    },

    aboutClassStudent: { // 获取班级下所有学生及学生可在本班级使用产品、当前选择的产品
        url: 'boss/classTeam/getStudent',
        method: 'get'
    },

    aboutClassSchoolStudent: { // 获取校区可进入当前班级的学生及购买的相关产品
        url: 'boss/classTeam/getSchoolStudents',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 教务中心--教师列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getTeacherList: { // 教师列表
        url: 'ums/teacherAllot',
        method: 'get'
    },
    getSchoolTeacherList: { // 校区的教师列表
        url: 'ums/teacherAllot/getSchoolTeacher',
        method: 'get'
    },

    getTeacherDetail: { // 教师获取教师授课详情
        url: 'ums/teacherAllot',
        method: 'get'
    },

    getTeacherOption: { // 更换、班级添加教师时获取教师列表
        url: 'ums/teacherAllot/lectureTeacherList',
        method: 'get'
    },

    updateTeacher: { // 教师授课
        url: 'ums/teacherAllot',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 排课列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getClassList: { // 获取班级列表
        url: 'boss/classTeam',
        method: 'get'
    },

    getSchedulingList: { // 获取班级列表
        url: 'boss/timeTable/getClassTimeTable',
        method: 'post'
    },

    getPersonTimeTable: { // 获取某个人的课表
        url: 'boss/timeTable/getPersonTimeTable',
        method: 'post'
    },

    gettimeTable: { // 获取某天全部课表
        url: 'boss/timeTable',
        method: 'get'
    },

    setTimeTable: { // 新增排课
        url: 'boss/timeTable',
        method: 'post'
    },

    editTimeTable: { // 修改排课
        url: 'boss/timeTable',
        method: 'put'
    },

    getTeacherByGradeAndSubjectAndIdle: { // 修改排课获取中可以修改的老师列表
        url: 'boss/timeTable/getTeacherByGradeAndSubjectAndIdle',
        method: 'get'
    },

    getShowInfo: { // 获取课表详情
        url: 'boss/timeTable/showInfo',
        method: 'post'
    },
    getTimeTableShow: { // 排课表菜单查看详情-----》获取课表详情
        url: 'boss/timeTable/getTimeTableShow',
        method: 'post'
    },

    getTimeTableStudentStatus: { // 根据获取班级下学生
        url: 'boss/timeTable/getTimeTableStudentStatus',
        method: 'post'
    },

    getExpectedClassCollection: { // 计算单次课收
        url: 'boss/productOrder/expectedClassCollection',
        method: 'post'
    },

    getUserByName: { // 通过姓名获取学生或者老师编号
        url: 'boss/bossCommon/getUserByName',
        method: 'get'
    },
    getUserSchoolByName: { // 通过姓名获取学生或者老师编号-----》本校区
        url: 'boss/bossCommon/getUserSchoolByName',
        method: 'get'
    },

    getSignTimeTableInfoAndAllStudent: { // 已经签到的排课信息和签到的学生信息和班级正常学员
        url: 'boss/timeTable/getSignTimeTableInfoAndAllStudent',
        method: 'get'
    },

    setSignTimeTableInfo: { // 修改课签
        url: 'boss/timeTable/setSignTimeTableInfo',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 教务中心--课签列表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    classSignList: { // 课签列表
        url: 'boss/timeTable/getSignedTimeTable',
        method: 'post'
    },

    getStudentSignBySchool: { //学生某个校区的课签列表
        url: 'boss/sign/getStudentSignBySchool',
        method: 'get'
    },

    getStudentSignAll: { //学生所有校区的课签列表
        url: 'boss/sign/getStudentSignAll',
        method: 'get'
    },

    classNoSignList: { // 补签列表
        url: 'boss/timeTable/getSupplementTimeTable',
        method: 'post'
    },

    createSupple: { // 补签
        url: 'boss/sign/supplementSign',
        method: 'post'
    },

    deleteTimeTable: { // 删除课签
        url: 'boss/timeTable',
        method: 'delete'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 打印 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    printViewPDF: { // 获得打印生成的pdf
        url: 'pub/print/viewToPdf',
        method: 'get'
    },

    printProductOrderView: { // 获得预览合同数据详情
        url: 'pub/print/printProductOrderToView',
        method: 'get'
    },

    approvalsCreate: { // 新建审批流程
        url: 'pub/approvals',
        method: 'post'
    },

    approvalsList: { // 获取审批流程管理列表
        url: 'pub/approvals',
        method: 'get'
    },

    approvalsInfo: { // 获取审批流程详情
        url: 'pub/approvals',
        method: 'get'
    },

    approvalsUpdate: { // 更新审批流
        url: 'pub/approvals',
        method: 'put'
    },

    approvalsStatus: { // 更新审批流状态
        url: 'pub/approvals/changeStatus',
        method: 'put'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 试听 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    applyAudition: { // 申请新试听
        url: 'boss/applyAudition',
        method: 'post'
    },

    auditionList: { // 试听列表
        url: 'boss/applyAudition',
        method: 'get'
    },

    auditionInfo: { // 试听详情
        url: 'boss/applyAudition',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 退费 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    refundSend: { // 退费申请
        url: 'boss/refund',
        method: 'post'
    },

    refundList: { // 退费列表
        url: 'boss/refund',
        method: 'get'
    },

    refundInfo: { // 退费详情
        url: 'boss/refund',
        method: 'get'
    },

    refundStatusUpdate: { // 退费状态修改
        url: 'boss/refund/setStatus',
        method: 'post'
    },
    refundStudentInfo: { // 获取退费学生相关信息
        url: 'boss/refund/refundStudentInfoByStudentID',
        method: 'get'
    },

    getApprovalFlow: { // 获取审批业务流分页列表
        url: 'boss/approvalFlow',
        method: 'get'
    },

    getApprovalFlowDetail: { // 获取审批流详情
        url: 'boss/approvalFlow',
        method: 'get'
    },

    putApprovalFlow: { // 审批流操作接口
        url: 'boss/approvalFlow',
        method: 'put'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 缩减产品<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    reduceOrderList: { // 缩减产品记录列表
        url: 'boss/productOrderReduceRecord',
        method: 'get'
    },

    reduceProduce: { // 缩减产品
        url: 'boss/productOrderReduceRecord',
        method: 'post'
    },

    reduceOrderInfo: { // 获取缩减产品订单信息
        url: 'boss/productOrderReduceRecord',
        method: 'get'
    },

    reduceOrderCalc: { // 缩减产品 实时计算
        url: 'boss/productOrderReduceRecord/calculation',
        method: 'post'
    },

    reduceOrderStudentInfo: { // 获取缩减课时学生相关信息
        url: 'boss/productOrderReduceRecord/reduceStudentInfoByStudentID',
        method: 'get'
    },

    repealApproval: { // 撤销审批接口
        url: 'boss/approvalFlow/cancel',
        method: 'put'
    },

    getStudentBase: { // 通过编号获去学生基本信息、家长信息及所属学校信息
        url: 'boss/bossCommon/getStudentBase',
        method: 'get'
    },

    getMultiStudent: { // 手机号/编号/姓名获取学生信息
        url: 'boss/student/getBranchStudent',
        method: 'get'
    },

    outMultiSchool: { // 转出申请多校区保存
        url: 'boss/studentSchoolMulti/outStudentMulti',
        method: 'post'
    },
    MultiSchool: { // 申请多校区保存
        url: 'boss/studentSchoolMulti',
        method: 'post'
    },

    MultiSchoolList: { // 申请多校list
        url: 'boss/studentSchoolMulti',
        method: 'get'
    },

    MultiSchoolInfo: { // 申请多校info
        url: 'boss/studentSchoolMulti',
        method: 'get'
    },

    getAutoList: {
        url: 'crm/schoolAssignDistribution',
        method: 'get'
    },

    addAutoList: {
        url: 'crm/schoolAssignDistribution',
        method: 'post'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 任务相关 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    addBranchTask: { // 分公司任务添加
        url: 'pub/task/branchTaskAdd',
        method: 'post'
    },

    branchTaskList: { // 分公司任务列表
        url: 'pub/task/branchTaskIndex',
        method: 'get'
    },

    branchTaskUpdate: { // 分公司任务修改
        url: 'pub/task/branchTaskUpdate',
        method: 'post'
    },

    branchTaskEnable: { // 分公司任务启用
        url: 'pub/task/branchTaskEnable',
        method: 'post'
    },

    branchTaskView: { // 分公司任务详情
        url: 'pub/task/branchTaskView',
        method: 'get'
    },

    branchMonthTaskList: { // 分公司任务列表[分公司人员操作]
        url: 'pub/task/branchMonthTaskIndex',
        method: 'get'
    },

    branchMonthTaskAdd: { // 分公司月度任务分解[分公司人员操作]
        url: 'pub/task/branchMonthTaskAdd',
        method: 'post'
    },

    schoolTaskList: { // 校区任务列表[分公司人员操作]
        url: 'pub/task/schoolTaskIndex',
        method: 'get'
    },

    schoolTaskView: { // 校区任务详情
        url: 'pub/task/schoolTaskView',
        method: 'get'
    },

    schoolTaskImport: { // 校区任务导入
        url: 'pub/task/schoolTaskImport',
        method: 'post'
    },

    schoolTaskImportTemplate: { // 校区任务导入模板下载
        url: 'pub/task/schoolTaskImportTemplate',
        method: 'get'
    },

    schoolTaskAdd: { // 校区部门月任务分解[校区人员操作]
        url: 'pub/task/schoolTaskAdd',
        method: 'post'
    },

    departmentTaskAdd: { // 校区部门月任务分解[校区人员操作]
        url: 'pub/task/departmentTaskAdd',
        method: 'post'
    },

    subjectGroupTaskAdd: { // 部门学科组任务分解[校区人员操作]
        url: 'pub/task/departmentSubjectGroupTaskAdd',
        method: 'post'
    },
    departmentSubjectGroupTaskView: { // 部门学科组任务详情[部门负责人操作]
        url: 'pub/task/departmentSubjectGroupTaskView',
        method: 'get'
    },
    departmentSubjectGroupIndex: { // 部门学科组任务列表[校区人操作]
        url: 'pub/task/departmentSubjectGroupIndex',
        method: 'get'
    },

    departmentIndex: { // 根据任务类型获取对应部门信息以及负责人信息[校区人员操作]
        url: 'pub/task/departmentIndex',
        method: 'get'
    },

    departmentTaskView: { // 部门任务详情[部门负责人操作]
        url: 'pub/task/departmentTaskView',
        method: 'get'
    },

    personTaskIndex: { // 员工任务列表[部门负责人操作]
        url: 'pub/task/personTaskIndex',
        method: 'get'
    },

    personTaskView: { // 根据任务类型获取对应员工任务详情[部门负责人操作]
        url: 'pub/task/personTaskView',
        method: 'get'
    },

    personTaskAdd: { // 员工任务添加[部门负责人操作]
        url: 'pub/task/personTaskAdd',
        method: 'post'
    },

    getPayList: { // 支付方式列表
        url: 'pub/pay',
        method: 'get'
    },

    creatPay: { // 支付方式创建
        url: 'pub/pay',
        method: 'post'
    },

    statusPay: { // 支付方式状态
        url: 'pub/pay/setStatus',
        method: 'put'
    },

    updatePositionDepartment: { // 调整员工部门信息
        url: 'ums/workerPosition/updatePositionDepartment',
        method: 'put'
    },
    expandClass: { // 班级扩展申请
        url: 'boss/classTeam/expandClass',
        method: 'post'
    },
    expandClassList: { // 申请扩班记录列表
        url: 'boss/classTeam/expandClassList',
        method: 'get'
    },
    expandClassShow: { // 扩班详情
        url: 'boss/classTeam/expandClassShow',
        method: 'get'
    },
    getBranchPayMethod: { // 获取分公司支付方式
        url: 'pub/department/getBranchPayMethod',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.9 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    getStudentChannelLogAll: { // 得到学生所有的对接渠道
        url: 'boss/student/getStudentChannelLogAll',
        method: 'get'
    },
    setStudentChannelAndPerson: { // 修改学生的对接渠道
        url: 'boss/student/setStudentChannelAndPerson',
        method: 'post'
    },
    setRechargeOrderChannelAndPerson: { // 修改充值订单的对接渠道以及客户录入人
        url: 'boss/rechargeOrder/setRechargeOrderChannelAndPerson',
        method: 'post'
    },
    setProductOrderChannelAndPerson: { // 修改产品订单的对接渠道以及客户录入人
        url: 'boss/productOrder/setProductOrderChannelAndPerson',
        method: 'post'
    },
    setStudentEndingClassAndExpend: { // 结课学生,并消耗校区剩余金额
        url: 'boss/studentSchools/setStudentEndingClassAndExpend',
        method: 'post'
    },
    setStudentEndingClass: { // 结课学生
        url: 'boss/studentSchools/setStudentEndingClass',
        method: 'post'
    },
    giveClassTimeApply: { // 赠送课时申请
        url: 'boss/bossCommon/giveClassTimeApply',
        method: 'post'
    },
    openClassApply: { // 手动申请开班
        url: 'boss/classTeam/openClassApply',
        method: 'post'
    },

    getIntroduction: { // 获取转介绍奖励规则
        url: 'pub/introduction',
        method: 'get'
    },
    postIntroduction: { // 添加转介绍奖励规则
        url: 'pub/introduction',
        method: 'post'
    },
    getIntroductionInfo: { // 获取转介绍奖励详情
        url: 'pub/introduction',
        method: 'get'
    },
    postIntroductionStatus: { // 修改规则状态
        url: 'pub/introduction/close',
        method: 'post'
    },

    getSubjectGroup: { // 获取学科组列表
        url: 'pub/subjectGroup',
        method: 'get'
    },
    getSubjectGroupInfo: { // 获取学科组列表
        url: 'pub/subjectGroup',
        method: 'get'
    },
    postSubjectGroup: { // 添加学科组
        url: 'pub/subjectGroup',
        method: 'post'
    },
    putSubjectGroup: { // 更新学科组
        url: 'pub/subjectGroup',
        method: 'put'
    },
    deleteSubjectGroup: { // 删除学科组
        url: 'pub/subjectGroup',
        method: 'delete'
    },
    addUserSubjectGroup: { // 添加所有老师到学科组
        url: 'pub/subjectGroup/addUser',
        method: 'post'
    },
    getTeacherResolve: { // 获取购买产品记录教师续费分解列表
        url: 'boss/teacherResolve',
        method: 'get'
    },
    postTeacherResolve: { // 学生续费分解保存按钮
        url: 'boss/teacherResolve',
        method: 'post'
    },
    getTeacherResolveInfo: { // 获取分解详情
        url: 'boss/teacherResolve',
        method: 'get'
    },
    getTearcherView: { // 获取授课教师信息  续费分解专用
        url: 'ums/teacherAllot/getTearcherView',
        method: 'get'
    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.10 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */

    callCenter: { // 呼叫中心资源池
        url: 'crm/callCenter',
        method: 'get'
    },
    putClassTeamTitle: { // 更新班级名称信息
        url: 'boss/classTeam/title',
        method: 'put'
    },
    putSubjectEdit: { // 更新学科信息
        url: 'pub/subject/edit',
        method: 'put'
    },
    buyEnrollmentIndex: { // 获取自招产品购买记录列表
        url: 'boss/productOrder/enrollmentIndex',
        method: 'get'
    },
    buyEnrollmentUpdate: { // 产品订单表修改自主招生分配比例
        url: 'boss/productOrder/enrollmentUpdate',
        method: 'post'
    },
    refundEnrollmentIndex: { // 获取自招产品退费记录列表
        url: 'boss/refund/enrollmentIndex',
        method: 'get'
    },
    refundEnrollmentUpdate: { // 退费表修改自主招生分配比例
        url: 'boss/refund/enrollmentUpdate',
        method: 'post'
    },
    getProductOrderByStudentAndEnrolment: { // 获取某个学生购买可退款的自主招生产品记录列表
        url: 'boss/productOrder/getProductOrderByStudentAndEnrolment',
        method: 'get'
    },
    enrolmentStore: { // 自主招生制度外退费申请
        url: 'boss/refund/enrolmentStore',
        method: 'post'
    },

    rechargeOrderExport: { // 充值订单导出
        url: 'boss/rechargeOrder/export',
        method: 'get',

    },
    productOrderReduceRecordExport: { // 缩减产品记录导出
        url: 'boss/productOrderReduceRecord/export',
        method: 'get',

    },
    productOrderExport: { // 购买订单导出
        url: 'boss/productOrder/export',
        method: 'get',

    },
    depositExport: { // 定金导出
        url: 'crm/customerDeposit/depositExport',
        method: 'get',

    },
    signedTimeTableExport: { // 课签导出
        url: 'boss/timeTable/getSignedTimeTableExport',
        method: 'post',

    },
    refundExport: { // 退费列表导出
        url: 'boss/refund/export',
        method: 'get',

    },
    refundEnrollmentIndexExport: { // 自招产品退费记录列表导出
        url: 'boss/refund/enrollmentIndexExport',
        method: 'get',

    },
    productOrderEnrollmentIndexExport: { // 自招产品购买分配导出
        url: 'boss/productOrder/enrollmentIndexExport',
        method: 'get',

    },
    teacherRefundExport: { // 退费教师退费分解列表导出
        url: 'boss/teacherRefund/teacherRefundExport',
        method: 'get',

    },
    teacherResolveExport: { // 退费教师续费分解列表导出
        url: 'boss/teacherResolve/teacherResolveExport',
        method: 'get',

    },
    taskPersonExport: { // 部门个人月度任务导出
        url: 'pub/task/taskPersonExport',
        method: 'get',

    },
    taskTotalExport: { // 线路任务总表导出
        url: 'pub/task/taskTotalExport',
        method: 'get',

    },
    geTeacherRefund: { // 获取退费记录教师退费分解列表
        url: 'boss/teacherRefund',
        method: 'get'
    },
    posTeacherRefund: { // 学生退费分解保存按钮
        url: 'boss/teacherRefund',
        method: 'post'
    },
    geTeacherRefundId: { // 获取退费分解详情
        url: 'boss/teacherRefund',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    monthStatisSchoolLearningClassTimeTask: { //学管课时量任务统计
        url: 'stat/schoolLearningClassTimeTask/monthStatisSchoolLearningClassTimeTask',
        method: 'get'
    },
    getBranchClassCoefficient: { // 分公司课时系数
        url: 'stat/branchClassCoefficient/getBranchClassCoefficient',
        method: 'get'
    },
    saveClassCoefficient: { // 编辑分公司课时系数
        url: 'stat/branchClassCoefficient/saveClassCoefficient',
        method: 'post'
    },
    getCommunity: { // 社群列表分页列表
        url: 'stat/community',
        method: 'get'
    },
    postCommunity: { // 新增社群信息
        url: 'stat/community',
        method: 'post'
    },
    getCommunityId: { // 社群详情
        url: 'stat/community',
        method: 'get'
    },
    putCommunity: { // 更新社群信息
        url: 'stat/community',
        method: 'put'
    },
    postEditPerson: { // 修改社群信息归属人
        url: 'stat/community/editPersonID',
        method: 'post'
    },
    postSetStatus: { // 社群信息状态修改
        url: 'stat/community/setStatus',
        method: 'post'
    },
    entyCommunityPersonNum: { // 社群人数录入
        url: 'stat/community/entyCommunityPersonNum',
        method: 'post'
    },
    editCommunityPersonNum: { // 社群人数修改
        url: 'stat/community/editPersonID',
        method: 'post'
    },
    getPersonByDepId: { // 获取当前登录用户所在部门中所有的员工
        url: 'ums/workerPosition/getPersonByDepId',
        method: 'get'
    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11渠道报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    communityStatisByBranch: { // 社群-分公司统计
        url: 'stat/communityStatis/communityStatisByBranch',
        method: 'get'
    },
    communityStatisByPerson: { // 社群-个人统计
        url: 'stat/communityStatis/communityStatisByPerson',
        method: 'get'
    },
    communityStatisByDepment: { // 社群-部门统计
        url: 'stat/communityStatis/communityStatisByDepment',
        method: 'get'
    },

    crmStatisSchoolByDay: { // 校区日统计
        url: 'stat/crmStatis/crmStatisSchoolByDay',
        method: 'get'
    },
    crmStatisSchoolByDayExport: { // 校区日统计导出
        url: 'stat/crmStatis/crmStatisSchoolByDayExport',
        method: 'get',

    },
    crmStatisSchoolByWeek: { // 校区周统计
        url: 'stat/crmStatis/crmStatisSchoolByWeek',
        method: 'get'
    },
    crmStatisSchoolByWeekExport: { // 校区周统计导出
        url: 'stat/crmStatis/crmStatisSchoolByWeekExport',
        method: 'get',

    },
    crmStatisSchoolByMonth: { // 校区月统计
        url: 'stat/crmStatis/crmStatisSchoolByMonth',
        method: 'get'
    },
    crmStatisSchoolByMonthExport: { // 校区月统计导出
        url: 'stat/crmStatis/crmStatisSchoolByMonthExport',
        method: 'get',

    },

    crmStatisBranchByDay: { // 分公司日统计
        url: 'stat/crmStatis/crmStatisBranchByDay',
        method: 'get'
    },
    crmStatisBranchByDayExport: { // 分公司日统计导出
        url: 'stat/crmStatis/crmStatisBranchByDayExport',
        method: 'get',

    },
    crmStatisBranchByWeek: { // 分公司周统计
        url: 'stat/crmStatis/crmStatisBranchByWeek',
        method: 'get',

    },
    crmStatisBranchByWeekExport: { // 分公司周统计导出
        url: 'stat/crmStatis/crmStatisBranchByWeekExport',
        method: 'get',

    },
    crmStatisBranchByMonth: { // 分公司月统计
        url: 'stat/crmStatis/crmStatisBranchByMonth',
        method: 'get'
    },
    crmStatisBranchByMonthExport: { // 分公司月统计导出
        url: 'stat/crmStatis/crmStatisBranchByMonthExport',
        method: 'get',

    },

    crmStatisMarketProductByDay: { // 营销产品日统计
        url: 'stat/crmStatis/crmStatisMarketProductByDay',
        method: 'get'
    },
    crmStatisMarketProductByDayExport: { // 营销产品日统计导出
        url: 'stat/crmStatis/crmStatisMarketProductByDayExport',
        method: 'get',

    },
    crmStatisMarketProductByWeek: { // 营销产品周统计
        url: 'stat/crmStatis/crmStatisMarketProductByWeek',
        method: 'get'
    },
    crmStatisMarketProductByWeekExport: { // 营销产品周统计导出
        url: 'stat/crmStatis/crmStatisMarketProductByWeekExport',
        method: 'get',

    },
    crmStatisMarketProductByMonth: { // 营销产品月统计
        url: 'stat/crmStatis/crmStatisMarketProductByMonth',
        method: 'get'
    },
    crmStatisMarketProductByMonthExport: { // 营销产品月统计导出
        url: 'stat/crmStatis/crmStatisMarketProductByMonthExport',
        method: 'get',

    },

    crmStatisGradeByDay: { // 年级日统计
        url: 'stat/crmStatis/crmStatisGradeByDay',
        method: 'get'
    },
    crmStatisGradeByDayExport: { // 年级日统计导出
        url: 'stat/crmStatis/crmStatisGradeByDayExport',
        method: 'get',

    },
    crmStatisGradeByWeek: { // 年级周统计
        url: 'stat/crmStatis/crmStatisGradeByWeek',
        method: 'get'
    },
    crmStatisGradeByWeekExport: { // 年级周统计导出
        url: 'stat/crmStatis/crmStatisGradeByWeekExport',
        method: 'get',

    },
    crmStatisGradeByMonth: { // 年级月统计
        url: 'stat/crmStatis/crmStatisGradeByMonth',
        method: 'get'
    },
    crmStatisGradeByMonthExport: { // 年级月统计导出
        url: 'stat/crmStatis/crmStatisGradeByMonthExport',
        method: 'get',

    },

    crmStatisDepartmentByDay: { // 部门日统计
        url: 'stat/crmStatis/crmStatisDepartmentByDay',
        method: 'get'
    },
    crmStatisDepartmentByDayExport: { // 部门日统计导出
        url: 'stat/crmStatis/crmStatisDepartmentByDayExport',
        method: 'get',

    },
    crmStatisDepartmentByWeek: { // 部门周统计
        url: 'stat/crmStatis/crmStatisDepartmentByWeek',
        method: 'get'
    },
    crmStatisDepartmentByWeekExport: { // 部门周统计导出
        url: 'stat/crmStatis/crmStatisDepartmentByWeekExport',
        method: 'get',

    },
    crmStatisDepartmentByMonth: { // 部门月统计
        url: 'stat/crmStatis/crmStatisDepartmentByMonth',
        method: 'get'
    },
    crmStatisDepartmentByMonthExport: { // 部门月统计导出
        url: 'stat/crmStatis/crmStatisDepartmentByMonthExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11综合报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    branchOrSchool: { // 校区/公司业绩报表
        url: 'stat/comprehensive/branchOrSchool',
        method: 'get'
    },
    branchOrSchoolReal: { // 校区/公司业绩报表实时
        url: '/dataapi/stat/branchOrSchool',
        method: 'get'
    },
    branchOrSchoolRealExport: { // 校区/公司业绩报表实时导出
        url: '/dataapi/stat/branchOrSchoolExport',
        method: 'get'
    },
    branchOrSchoolExport: { // 校区/公司业绩报表导出57
        url: 'stat/comprehensive/branchOrSchoolExport',
        method: 'get',

    },
    completionRate: { // 校区/公司完成率
        url: 'stat/comprehensive/completionRate',
        method: 'get'
    },
    completionRateReal: { // 校区/公司完成率实时
        url: '/dataapi/stat/completionRate',
        method: 'get'
    },
    completionRateRealExport: { // 校区/公司完成率实时导出
        url: '/dataapi/stat/completionRateExport',
        method: 'get'
    },
    completionRateExport: { // 校区/公司完成率导出58
        url: 'stat/comprehensive/completionRateExport',
        method: 'get',

    },
    studentsDistributed: { // 校区学员分布统计接口
        url: 'stat/comprehensive/studentsDistributed',
        method: 'get'
    },
    studentsDistributedExport: { // 校区学员分布统计接口导出59
        url: 'stat/comprehensive/studentsDistributedExport',
        method: 'get',

    },
    schoolStudentStat: { // 校区学生统计
        url: 'stat/comprehensive/schoolStudentStat',
        method: 'get'
    },
    schoolStudentStatExport: { // 校区学生统计导出60
        url: 'stat/comprehensive/schoolStudentStatExport',
        method: 'get',

    },
    contractComparison: { // 签约同期对比
        url: 'stat/comprehensive/contractComparison',
        method: 'get'
    },
    contractComparisonExport: { // 签约同期对比导出61
        url: 'stat/comprehensive/contractComparisonExport',
        method: 'get',

    },
    signedComparison: { // 课收同期对别
        url: 'stat/comprehensive/signedComparison',
        method: 'get'
    },
    signedComparisonExport: { // 课收同期对别导出62
        url: 'stat/comprehensive/signedComparisonExport',
        method: 'get',

    },
    unitPrice: { // 校区课时单价接口
        url: 'stat/comprehensive/unitPrice',
        method: 'get'
    },
    unitPriceExport: { // 校区课时单价接口导出
        url: 'stat/comprehensive/unitPriceExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11咨询报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    preSchoolPerformance: { // 咨询报表-校区前期业绩报表
        url: 'stat/consultationReportForm/preSchoolPerformance',
        method: 'get'
    },
    preSchoolPerformanceExport: { // 咨询报表-校区前期业绩报表导出
        url: 'stat/consultationReportForm/preSchoolPerformanceExport',
        method: 'get',

    },
    schoolConsultationPerformanceStatistics: { // 咨询报表-校区咨询师业绩统计
        url: 'stat/consultationReportForm/schoolConsultationPerformanceStatistics',
        method: 'get'
    },
    schoolConsultationPerformanceStatisticsExport: { // 咨询报表-校区咨询师业绩统计导出
        url: 'stat/consultationReportForm/schoolConsultationPerformanceStatisticsExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11学管报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    schoolAfterStatistic: { // 学管-校区后期业绩统计
        url: 'stat/studentManager/schoolAfterStatistic',
        method: 'get'
    },
    schoolAfterExport: { // 学管-校区后期业绩统计导出
        url: 'stat/studentManager/schoolAfterExport',
        method: 'get',

    },
    perStatistic: { // 学管-学管师业绩统计
        url: 'stat/studentManager/perStatistic',
        method: 'get'
    },
    perExport: { // 学管-学管师业绩统计导出
        url: 'stat/studentManager/perExport',
        method: 'get',

    },
    classHoursExport: { // 学管-学管学生课时汇总导出
        url: 'stat/studentManager/classHoursExport',
        method: 'get',

    },
    classHoursStatistic: { // 学管-学管学生课时汇总
        url: 'stat/studentManager/classHoursStatistic',
        method: 'get'
    },
    studentHoursStatistic: { // 学管-学生课时量统计
        url: 'stat/studentManager/studentHoursStatistic',
        method: 'get'
    },
    studentHoursExport: { // 学管-学生课时量统计导出
        url: 'stat/studentManager/studentHoursExport',
        method: 'get',

    },
    schoolStudentExport: { // 学管-校区学生统计导出
        url: 'stat/studentManager/schoolStudentExport',
        method: 'get',

    },
    schoolStudentStatistic: { // 学管-校区学生统计
        url: 'stat/studentManager/schoolStudentStatistic',
        method: 'get'
    },
    managerStudentStatistic: { // 学管-学管管理学员统计
        url: 'stat/studentManager/managerStudentStatistic',
        method: 'get'
    },
    managerStudentExport: { // 学管-学管管理学员统计导出
        url: 'stat/studentManager/managerStudentExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11教学报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    monthStatisTeacherGradeSubjectByMonth: { //教师年级科目统计
        url: 'stat/teachingStatistics/monthStatisTeacherGradeSubjectByMonth',
        method: 'get'
    },
    monthStatisTeacherGradeSubjectByMonthExport: { //教师年级科目统计Export
        url: 'stat/teachingStatistics/monthStatisTeacherGradeSubjectByMonthExport',
        method: 'get',

    },
    monthStatisSchoolClassTypeReceiveByMonth: { //校区班型课收统计
        url: 'stat/teachingStatistics/monthStatisSchoolClassTypeReceiveByMonth',
        method: 'get'
    },
    monthStatisSchoolClassTypeReceiveByMonthExport: { //校区班型课收统计Export
        url: 'stat/teachingStatistics/monthStatisSchoolClassTypeReceiveByMonthExport',
        method: 'get',

    },
    monthStatisSchoolTasksByMonth: { //校区课签统计
        url: 'stat/teachingStatistics/monthStatisSchoolTasksByMonth',
        method: 'get'
    },
    monthStatisSchoolTasksByMonthExport: { //校区课签统计Export
        url: 'stat/teachingStatistics/monthStatisSchoolTasksByMonthExport',
        method: 'get',

    },
    monthStatisTeacherClassSignNumberByMonth: { // 教师课时量综合统计
        url: 'stat/teachingStatistics/monthStatisTeacherClassSignNumberByMonth',
        method: 'get'
    },
    monthStatisTeacherClassSignNumberByMonthExport: { // 教师课时量综合统计导出
        url: 'stat/teachingStatistics/monthStatisTeacherClassSignNumberByMonthExport',
        method: 'get',

    },
    monthStatisSchoolTeacherRemainByMonth: { // 校区教师留存统计
        url: 'stat/teachingStatistics/monthStatisSchoolTeacherRemainByMonth',
        method: 'get'
    },
    monthStatisSchoolTeacherRemainByMonthExport: { // 校区教师留存统计导出
        url: 'stat/teachingStatistics/monthStatisSchoolTeacherRemainByMonthExport',
        method: 'get',

    },
    monthStatisSchoolClassCoefficientByMonth: { // 校区课时系数
        url: 'stat/teachingStatistics/monthStatisSchoolClassCoefficientByMonth',
        method: 'get'
    },
    monthStatisSchoolClassCoefficientByMonthExport: { // 校区课时系数导出
        url: 'stat/teachingStatistics/monthStatisSchoolClassCoefficientByMonthExport',
        method: 'get',

    },
    getSchoolSignSituationStatistics: { // 教学报表-校区课签情况统计
        url: 'stat/consultationReportForm/getSchoolSignSituationStatistics',
        method: 'get'
    },
    schoolSignSituationStatisticsExport: { // 教学报表-校区课签情况统计导出
        url: 'stat/consultationReportForm/schoolSignSituationStatisticsExport',
        method: 'get',

    },

    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11财务报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    contractTypeIndex: { // 合同类型统计列表
        url: 'stat/finance/contractTypeIndex',
        method: 'get'
    },
    contractTypeExport: { // 合同类型统计导出
        url: 'stat/finance/contractTypeExport',
        method: 'get',

    },
    advanceCollectIndex: { // 预收汇总统计列表
        url: 'stat/finance/advanceCollectIndex',
        method: 'get'
    },
    advanceCollectExport: { // 预收汇总统计导出
        url: 'stat/finance/advanceCollectExport',
        method: 'get',

    },
    enrollmentIndex: { // 自主招生财务汇总统计列表
        url: 'stat/finance/enrollmentIndex',
        method: 'get'
    },
    enrollmentView: { // 自主招生财务汇总统计详情
        url: 'stat/finance/enrollmentView',
        method: 'get'
    },
    enrollmentExport: { // 自主招生财务汇总统计导出
        url: 'stat/finance/enrollmentExport',
        method: 'get',

    },
    refundIndex: { // 退费汇总表统计列表
        url: 'stat/finance/refundIndex',
        method: 'get'
    },
    statRefundExport: { // 退费汇总表统计导出
        url: 'stat/finance/refundExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 2.0.11人事报表 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    teacherIndex: { // 教师1对1课时统计列表
        url: 'stat/personnel/teacherIndex',
        method: 'get'
    },
    teacherExport: { // 教师1对1课时统计导出
        url: 'stat/personnel/teacherExport',
        method: 'get',

    },
    teacherClassIndex: { // 教师班组课时统计列表
        url: 'stat/personnel/teacherClassIndex',
        method: 'get'
    },
    teacherClassExport: { // 教师班组课时统计导出
        url: 'stat/personnel/teacherClassExport',
        method: 'get',

    },
    subjectGroupIndex: { // 学科组课时收入统计列表
        url: 'stat/personnel/subjectGroupIndex',
        method: 'get'
    },
    subjectGroupView: { // 学科组课时收入统计详情
        url: 'stat/personnel/subjectGroupView',
        method: 'get'
    },
    subjectGroupExport: { // 学科组课时收入统计导出
        url: 'stat/personnel/subjectGroupExport',
        method: 'get',

    },
    schoolSignIndex: { // 校区签单统计（前后期）统计列表
        url: 'stat/personnel/schoolSignIndex',
        method: 'get'
    },
    schoolSignExport: { // 校区签单统计（前后期）统计导出
        url: 'stat/personnel/schoolSignExport',
        method: 'get',

    },
    managementIndex: { // 学管1对1课时统计列表
        url: 'stat/personnel/managementIndex',
        method: 'get'
    },
    managementExport: { // 学管1对1课时统计统计导出
        url: 'stat/personnel/managementExport',
        method: 'get',

    },
    managementClassIndex: { // 学管班组课时统计列表
        url: 'stat/personnel/managementClassIndex',
        method: 'get'
    },
    managementClassExport: { // 学管班组课时统计导出
        url: 'stat/personnel/managementClassExport',
        method: 'get',

    },

    teacherClassSigning: { // 教务中心-教师课签明细
        url: 'stat/educationalcore/teacherClassSigning',
        method: 'get'
    },
    teacherClassSignExport: { // 教务中心-教师课签明细导出
        url: 'stat/educationalcore/teacherClassSignExport',
        method: 'get',

    },
    studentClassSigning: { // 教务中心-学生课签明细
        url: 'stat/educationalcore/studentClassSigning',
        method: 'get'
    },
    studentClassSignExport: { // 教务中心-学生课签明细导出
        url: 'stat/educationalcore/studentClassSignExport',
        method: 'get',

    },
    /* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 精雕细课接口 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    getjdxkTimeTable: { // 获取精雕细课课表
        url: 'jdxk/jdxk',
        method: 'get'
    },
    postjdxkTimeTable: { // 添加课表
        url: 'jdxk/jdxk',
        method: 'post'
    },
    putjdxkTimeTable: { // 修改课表
        url: 'jdxk/jdxk',
        method: 'put'
    },
    postjdxkdetails: { // 批量创建课表推送计划
        url: 'jdxk/jdxk/details',
        method: 'post'
    },
    getjdxkStudents: { // 获取校区内报了精雕细课的学生
        url: 'jdxk/jdxk/students',
        method: 'get'
    },
    jdxkTimeStudents: { // time_id获取课表学生列表
        url: 'jdxk/jdxk/timeStudents',
        method: 'get'
    },
    postjdxkStudents: { // 给课表添加学生
        url: 'jdxk/jdxk/students',
        method: 'post'
    },
    deletejdxkStudents: { // 课表删除学生
        url: 'jdxk/jdxk/students',
        method: 'delete'
    },
    putjdxkTeacher: { // id更换老师
        url: 'jdxk/jdxk/teacher',
        method: 'put'
    },
    jdxkgetCourse: { // 获取精雕细课课程讲次
        url: 'jdxk/jdxk/getCourse',
        method: 'get'
    },
    getjdxkPushPlan: { // id获取课表推送计划
        url: 'jdxk/jdxk',
        method: 'get'
    },
    getjdxkPushList: { // 获取精雕细课推送记录
        url: 'jdxk/jdxk/push/list',
        method: 'get'
    },
    getjdxkDetails: { // time_id获取精雕细课讲次
        url: 'jdxk/jdxk/details',
        method: 'get'
    },
    getjdxkGradeSubject: { // 年级和学科
        url: 'jdxk/jdxk/grade/subject',
        method: 'get'
    },
    getjdxkLastTime: { // 获取精雕细课最后一次推送时间
        url: 'jdxk/jdxk/push/time',
        method: 'get'
    },
    getFailPushStudent: { // 获取课表推送失败学生列表
        url: 'jdxk/jdxk/timeStudents/fail',
        method: 'get'
    },
    postPush: { // 补推
        url: 'jdxk/jdxk/push',
        method: 'post'
    },
    clearProtectionPeriod: { // 清空部门&校区保护期
        url: 'crm/customerSchool/clearProtectionPeriod',
        method: 'post'
    },
    invalidRechargeOrder: { // 作废充值订单
        url: 'boss/rechargeOrder/invalidRechargeOrder',
        method: 'post'
    },
    setRechargeOrderReconciliation: { // 充值订单对账，取消对账
        url: 'boss/rechargeOrder/setRechargeOrderReconciliation',
        method: 'post'
    },
    setRechargeOrderInfo: { // 修改充值订单，收取人和收款方式
        url: 'boss/rechargeOrder/setRechargeOrderInfo',
        method: 'post'
    },
    updateStudentProduct: { // 批量更新班级学生产品信息
        url: 'boss/classTeam/studentProduct',
        method: 'put'
    },
    autoMaticIncomeIndex: { // 财务收入明细列表
        url: 'boss/automaticIncome/index',
        method: 'get'
    },
    autoMaticIncomeExport: { // 财务收入明细列表导出
        url: 'boss/automaticIncome/export',
        method: 'get',

    },
    postBalanceTransfer: { // 余额转移申请
        url: 'boss/balanceTransfer',
        method: 'post'
    },
    getBalanceTransfer: { // 余额转移申请列表
        url: 'boss/balanceTransfer',
        method: 'get'
    },
    getBalanceTransferExport: { // 余额转移列表导出
        url: 'boss/balanceTransfer/export',
        method: 'get',

    },
    getInfoBalanceTransfer: { // 余额转移申请详情
        url: 'boss/balanceTransfer',
        method: 'get'
    },
    getAllTimeTable: { // 获取某个时间段所有课表信息
        url: 'boss/timeTable/getAllTimeTable',
        method: 'get'
    },
    /************************* 2.0.21版本接口 ************************************/
    introductionStudentExport: { //转介绍导出
        url: 'boss/student/introductionStudentExport',
        method: 'get',

    },
    customerVisitExport: { //客户上门管理导出
        url: 'crm/visit/customerVisitExport',
        method: 'get',

    },
    getStudentSignInfoAndItsInfoBySchool: { //获取某个时间段所有课签信息,its的课签信息
        url: 'boss/sign/getStudentSignInfoAndItsInfoBySchool',
        method: 'get'
    },
    studentClassSignSendMail: { //教务中心-学生课签明细导出发邮件
        url: 'stat/educationalcore/studentClassSignSendMail',
        method: 'post'
    },
    teacherClassSignSendMail: { //教务中心-老师课签明细导出发邮件
        url: 'stat/educationalcore/teacherClassSignSendMail',
        method: 'post'
    },
    /* 2.0.22----2.0.23 */
    rechargeOrderReconciliationSearchExecute: { //教务中心-老师课签明细导出发邮件
        url: 'boss/rechargeOrder/rechargeOrderReconciliationSearchExecute',
        method: 'get'
    },
    delTime: { //删除课表
        url: 'jdxk/jdxk/del/time',
        method: 'delete'
    },
    /* 2.0.27 */
    editClassType: { //修改班型
        url: 'pub/classType',
        method: 'put'
    },

    /* 2.0.25 */
    statjdxkTeacher: {
        url: 'stat/jdxk/teacher',
        method: 'get'
    },
    statjdxkStudent: {
        url: 'stat/jdxk/student',
        method: 'get'
    },
    jdxkStudentExport: {
        url: 'stat/jdxk/studentExport',
        method: 'get',

    },
    jdxkTeacherExport: {
        url: 'stat/jdxk/teacherExport',
        method: 'get',

    },
    jdxkListExportt: {
        url: 'jdxk/jdxk/push/listExport',
        method: 'get',

    },
    /**** 2.0.28 ****/
    superClassIndex: { // 获取超级班信息列表
        url: 'boss/superClass',
        method: 'get'
    },
    superClassAdd: { // 添加超级班
        url: 'boss/superClass',
        method: 'post'
    },
    superClassDetail: { // 超级班信息
        url: 'boss/superClass',
        method: 'get'
    },
    superClassUpdateTitle: { // 修改超级班名称
        url: 'boss/superClass',
        method: 'put'
    },
    superClassUpdateTeacher: { // 修改超级班老师
        url: 'boss/superClass/updateTeacher',
        method: 'post'
    },
    superClassSchoolStudentIndex: { // 班级学生管理－学生校区分布情况
        url: 'boss/superClass/schoolStudentIndex',
        method: 'get'
    },
    superClassClassStudentIndex: { // 班级学生管理－学生列表
        url: 'boss/superClass/classStudentIndex',
        method: 'get'
    },
    superClassClassStudentAdd: { // 班级学生管理－学生添加
        url: 'boss/superClass/addClassStudent',
        method: 'post'
    },
    superClassClassStudentUpdate: { // 班级学生管理－学生编辑
        url: 'boss/superClass/updateClassStudent',
        method: 'post'
    },
    superClassClassStudentDel: { // 班级学生管理－学生删除
        url: 'boss/superClass/deleteClassStudent',
        method: 'post'
    },
    getTeacherByNameOrId: { // 通过姓名或编号得到老师信息
        url: 'ums/teacherAllot/getTeacherByNameOrId',
        method: 'get'
    },
    getStudentSignInfoAndItsInfoBySchoolExport: { // 获取某个时间段所有课签信息,its的课签信息导出
        url: 'boss/sign/getStudentSignInfoAndItsInfoBySchoolExport',
        method: 'get',

    },
    updatePrintPerson: { // 更新打印者信息
        url: 'boss/refund/updatePrintPerson',
        method: 'post'
    },
    superGetAllTimeTable: { // 获取某个时间段所有超级大课课表信息
        url: 'boss/superTimeTable/getAllTimeTable',
        method: 'get'
    },
    superGetschedulingList: { // 获取某个班级，某个时间段的课表列表信息
        url: 'boss/superTimeTable/getClassTimeTable',
        method: 'post'
    },
    superGetTimeTableStudentStatus: { // 获取某个超级班，上课时间，结束时间，班级中学生状态
        url: 'boss/superTimeTable/getTimeTableStudentStatus',
        method: 'post'
    },
    superTimeTable: { // 超级班新增排课
        url: 'boss/superTimeTable',
        method: 'post'
    },
    superGetShowInfo: { // 获取超课课表详细信息
        url: 'boss/superTimeTable/showInfo',
        method: 'get'
    },
    superExpectedClassCollection: { // 超级大课排课时预计课收计算
        url: 'boss/superTimeTable/expectedClassCollection',
        method: 'post'
    },
    getTimeTableStudentList: { // 获取超级排课表中学生信息（带分页）
        url: 'boss/superTimeTable/getTimeTableStudentList',
        method: 'get'
    },
    superDeleteTimeTable: { // 删除课签
        url: 'boss/superTimeTable',
        method: 'delete'
    },
    superClassTeacherSigningDetails: { // 超课教师课签明细
        url: 'boss/sign/superClassTeacherSigningDetails',
        method: 'get'
    },
    superClassTeacherSigningDetailsExport: { // 超课教师课签明细导出
        url: 'boss/sign/superClassTeacherSigningDetailsExport',
        method: 'get',

    },
    superClassStudentSigningDetails: { // 超课学生课签明细
        url: 'boss/sign/superClassStudentSigningDetails',
        method: 'get'
    },
    superClassStudentSigningDetailsExport: { // 超课学生课签明细导出
        url: 'boss/sign/superClassStudentSigningDetailsExport',
        method: 'get',

    },
    /* 2.0.29 */
    systemSubjectGroupExport: { // 学科组管理导出
        url: 'pub/subjectGroup/subjectGroupExport',
        method: 'get',

    },
    getManualEndClass: { // {id}手动结束班级
        url: 'boss/classTeam/manualEndClass',
        method: 'get',
    },
    manualConfirmClassHours: { // 确认赠送课时
        url: 'boss/productOrderReduceRecord/manualConfirmClassHours',
        method: 'post',
    },
    /* 2.0.30 */
    pcVersionIndex: { // pc版本更新记录列表接口
        url: 'pub/pcVersion',
        method: 'get',
    },
    pcVersion: { // 发布版本接口
        url: 'pub/pcVersion',
        method: 'post',
    },
    pcVersionEnd: { // 结束更新
        url: 'pub/pcVersion',
        method: 'put',
    },
    pcVersionIng: { // 获取当前正在更新的版本接口
        url: 'pub/pcVersion/currentUpdate',
        method: 'get',
    },
    whiteListIndex: { // 白名单列表
        url: 'pub/whiteList',
        method: 'get',
    },
    whiteList: { // 白名单添加
        url: 'pub/whiteList',
        method: 'post',
    },
    whiteListDel: { // 白名单删除
        url: 'pub/whiteList',
        method: 'delete',
    },
    whiteListEnable: { // 白名单启用
        url: 'pub/whiteList/enable',
        method: 'post',
    },
    whiteListDisable: { // 白名单禁用
        url: 'pub/whiteList/disable',
        method: 'post',
    },

    /* 2.0.32 */
    checkUpdateTeacherCondition: { // 获取班级更换老师条件
        url: 'team/classTeam/checkUpdateTeacherCondition',
        method: 'get',
    },
    updateTeacherClassTeam: { // 更新班级教师信息
        url: 'team/classTeam/updateTeacher',
        method: 'post',
    },
    teamManualEndClass: { //手动结束班级
        url: 'team/classTeam/manualEndClass',
        method: 'get',
    },
    teamClassTeam: { //添加新班级
        url: 'team/classTeam',
        method: 'post'
    },
    teamTimeTable: { //班级课表
        url: 'team/timeTable',
        method: 'get'
    },
    getStudentCanConvertClassList: { //查询可转班级
        url: 'team/classTeam/getStudentCanConvertClassList',
        method: 'get'
    },
    studentCanConverClass: { //学生转班级
        url: 'team/classTeam/studentCanConverClass',
        method: 'post'
    },
    getBuyClassTeamProduct: { //得到可购买的班课列表
        url: 'team/classTeam/getBuyClassTeamProduct',
        method: 'get'
    },
    calculationTeamProduct: { //购买班课产品 实时计算价格
        url: 'team/classTeam/calculationTeamProduct',
        method: 'post'
    },
    storeTeamProduct: { //购买班课产品保存
        url: 'team/classTeam/storeTeamProduct',
        method: 'post'
    },
    teamCalculation: { //班课产品_缩减产品_实时计算
        url: 'team/productOrderReduceRecord/calculation',
        method: 'post'
    },
    teamProductOrderReduceRecord: { //班课产品_缩减产品
        url: 'team/productOrderReduceRecord',
        method: 'post'
    },
    transferRecords: { //转班记录
        url: 'team/classTeam/transferRecords',
        method: 'get'
    },
    /* 2.0.33 */
    studentExport: { //学生列表导出
        url: 'boss/student/export',
        method: 'get'
    },
    teacherTeamIndex: { //教师班课课时统计列表
        url: 'stat/personnel/teacherTeamIndex',
        method: 'get'
    },
    teacherTeamExport: { //教师班课课时统计列表导出
        url: 'stat/personnel/teacherTeamExport',
        method: 'get'
    },
    managementTeamIndex: { //学管班课课时统计列表导出
        url: 'stat/personnel/managementTeamIndex',
        method: 'get'
    },
    managementTeamExport: { //学管班课课时统计列表导出
        url: 'stat/personnel/managementTeamExport',
        method: 'get'
    },
    branchAllTimeTableSendMail: { //教务中心-所有课表导出发邮件
        url: 'stat/educationalcore/branchAllTimeTableSendMail',
        method: 'post'
    },
    getSchoolAllTimeTableExport: { //教务中心-校区排课的列表导出
        url: 'boss/timeTable/getSchoolAllTimeTableExport',
        method: 'get'
    },

    /* 2.1.0 */
    tagsGroupList: { //标签分组-列表
        url: 'pub/tagsGroup',
        method: 'get'
    },
    tagsGroupCreate: { //标签分组-创建
        url: 'pub/tagsGroup',
        method: 'post'
    },
    tagsGroupUpdate: { //标签分组-编辑
        url: 'pub/tagsGroup',
        method: 'put'
    },
    tagsGroupDelete: { //标签分组-删除
        url: 'pub/tagsGroup',
        method: 'delete'
    },
    tagsList: { //标签-列表
        url: 'pub/tags',
        method: 'get'
    },
    tagsCreate: { //标签-新增
        url: 'pub/tags',
        method: 'post'
    },
    tagsUpdate: { //标签-修改
        url: 'pub/tags',
        method: 'put'
    },
    tagsDelete: { //标签-删除
        url: 'pub/tags',
        method: 'delete'
    },
    tagsMoveGroup: { //标签-移动分组
        url: 'pub/tags/moveGroup',
        method: 'put'
    },
    tagsRefresh: { //标签-刷新
        url: 'pub/tags/refresh',
        method: 'get'
    },
    tagsStatus: { //标签-停用启用
        url: 'pub/tags/status',
        method: 'get'
    },
    customerUserFollow: { //客户的全部跟踪记录
        url: 'crm/customer/customerUserFollow',
        method: 'get',
    },
    getCustomerChannelList: { //客户的所有渠道信息
        url: 'crm/customer/getCustomerChannelList',
        method: 'get',
    },
    getCustomerTags: { //获取客户标签
        url: 'crm/customer/getCustomerTags',
        method: 'get',
    },
    doorCustomerAdd: { //上门登记客户录入
        url: 'crm/customer',
        method: 'post',
    },
    getCustomerSchoolList: { //客户的所有对接校区
        url: 'crm/customer/getCustomerSchoolList',
        method: 'get',
    },
    getCustomerWorkOrderList: { //获取客户工单列表
        url: 'crm/customer/getCustomerWorkOrderList',
        method: 'get',
    },
    searchWorkOrderList: { //工单筛选后下一步筛选出的列表
        url: 'crm/workOrderRoutine/customerList',
        method: 'get'
    },
    workOrderAdd: { //工单添加
        url: 'crm/workOrderRoutine',
        method: 'post'
    },
    getWorkOrderRoutine: {
        url: 'crm/workOrderRoutine',
        method: 'get'
    },
    workOrderRoutineAccept: {
        url: 'crm/workOrderRoutine/accept',
        method: 'put'
    },
    workOrderRoutineRefuse: {
        url: 'crm/workOrderRoutine/refuse',
        method: 'put'
    },
    getWorkOrderRoutineDetail: {
        url: 'crm/workOrderRoutine',
        method: 'get'
    },
    getWorkCustomerList: {
        url: 'crm/workOrderRoutine/workCustomerList',
        method: 'get'
    },
    getWorkCustomerIDs: { // 普通工单-新建工单搜索客户所有ID
        url: 'crm/workOrderRoutine/getCustomerIds',
        method: 'get'
    },
    workOrderRoutinefinishFollow: {
        url: 'crm/workOrderRoutine/finishFollow',
        method: 'post'
    },
    getMineWorkRoutineList: {
        url: 'crm/workOrderRoutine/myList',
        method: 'get'
    },
    workOrderRoutineFinish: {
        url: 'crm/workOrderRoutine/finish',
        method: 'post'
    },
    workOrderRoutineDistributio: {
        url: 'crm/workOrderRoutine/distribution/workOrder',
        method: 'post'
    },
    workOrderRoutineAutoDistributio: {
        url: 'crm/workOrderRoutine/autoDistribution/workOrder',
        method: 'post'
    },
    workOrderRoutineAutoCustomerService: {
        url: 'crm/workOrderRoutine/distribution/customerService',
        method: 'post'
    },
    workOrderRoutineAutoCheckFinish: {
        url: 'crm/workOrderRoutine/checkFinish',
        method: 'get'
    },
    getCustomerServiceList: {
        url: 'crm/workOrderRoutine/getCustomerServiceList',
        method: 'get'
    },
    workOrderCustomerDetail: { //工单客户-详情
        url: 'crm/workOrderCustomer',
        method: 'get'
    },
    studentBalanceTransfer: { //{id}获取学生的所有转余额
        url: 'boss/balanceTransfer/studentBalanceTransfer',
        method: 'get'
    },
    /* 2.1.2 */
    smsTemplateList:{//短信模板列表
        url: 'pub/smsTemplate',
        method: 'get'
    },
    smsTemplateListAdd:{//短信模板添加
        url: 'pub/smsTemplate',
        method: 'post'
    },
    smsTemplateListEdit:{//{id}短信模板编辑
        url: 'pub/smsTemplate',
        method: 'put'
    },
    smsTemplateListStatus: {// {id}短信模板-启用禁用
        url: 'pub/smsTemplate/status',
        method: 'get'
    },
    smsMessageList: {// {id}消息中台推送平台列表
        url: 'pub/messagePush/pushPlatform',
        method: 'get'
    },
    // 消息推送
    messagePushList: {//消息推送-列表
        url: 'pub/messagePush',
        method: 'get'
    },
    AddMessagePushList: {//消息推送-创建
        url: 'pub/messagePush',
        method: 'post'
    },
    AddMessageSinglePush: {//{id}消息推送-单挑推送
        url: 'pub/messagePush',
        method: 'get'
    },
    CompileMessage: {//{id}消息推送-编辑
        url: 'pub/messagePush',
        method: 'put'
    },
    StatusMessage: {//{id}消息推送-启用停用
        url: 'pub/messagePush/status',
        method: 'get'
    },
    // 消息中心列表
    GetMessageLogList: {//消息中心-列表
        url: 'pub/messageLog',
        method: 'get'
    },
    GetMessageLogListDetails: {//{id}消息中心-查看
        url: 'pub/messageLog/read',
        method: 'get'
    },

    /* 2.1.3 */
    refreshAllRoleManage: { // 更新所有权限功能
        url: 'ums/roleManage/refreshAllRoleManage',
        method: 'get'
    },
    deletePosition: { // 职位状态
        url: 'ums/position',
        method: 'delete'
    },
    replacePosition: { // 员工旧职位信息替换成新职位信息
        url: 'ums/position/replacePosition',
        method: 'post'
    },
    /* 2.1.7 */
    channelExport: { // 渠道导出
        url: 'pub/channel/export',
        method: 'get'
    },

    /* 2.1.1 */
    workOrderActivity: { // 活动工单-列表
        url: 'crm/workOrderActivity',
        method: 'get'
    },
    workOrderActivityInfo: { // 活动工单-详情
        url: 'crm/workOrderActivity',
        method: 'get'
    },
    postWorkOrderActivity: { // 活动工单-新增
        url: 'crm/workOrderActivity',
        method: 'post'
    },
    putWorkOrderActivity: { // 活动工单-编辑
        url: 'crm/workOrderActivity',
        method: 'put'
    },
    workOrderActivityStatus: { // {id}活动工单-启用禁用
        url: 'crm/workOrderActivity/status',
        method: 'get'
    },
    workOrderActivityService: { // 活动工单-手动分配客服
        url: 'crm/workOrderActivity/distribution/customerService',
        method: 'post'
    },
    workOrderActivityDistribution: { // 活动工单-手动分配工单
        url: 'crm/workOrderActivity/distribution/workOrder',
        method: 'post'
    },
    workOrderActivityAutoDistribution: { // 活动工单-自动分配工单配置
        url: 'crm/workOrderActivity/autoDistribution/workOrder',
        method: 'post'
    },
    workOrderActivitygetCustomerServiceList: { // 活动工单-自动分配客服列表
        url: 'crm/workOrderActivity/getCustomerServiceList',
        method: 'get'
    },
    workOrderActivityCustomerList: { // 活动工单-查看详情客户列表
        url: 'crm/workOrderActivity/workCustomerList',
        method: 'get'
    },
    workOrderActivityfinishFollow: { // 活动工单-工单内批量完成跟进
        url: 'crm/workOrderActivity/finishFollow',
        method: 'post'
    },
    workOrderActivitymyList: { // 活动工单-个人工单
        url: 'crm/workOrderActivity/myList',
        method: 'get'
    },
    channelPromoter: { // 设置无推广人客户分配
        url: 'crm/channelPromoter',
        method: 'post'
    },
    getchannelPromoter: { // 获取设置的无推广人客户分配
        url: 'crm/channelPromoter/getInfo',
        method: 'get'
    },
    /* 2.2.1 */
    groupTeamList: { // 获取分组信息列表
        url: 'boss/groupTeam',
        method: 'get'
    },
    groupTeamAdd: { // 添加新分组
        url: 'boss/groupTeam',
        method: 'post'
    },
    groupTeamDelete: { // 删除分组
        url: 'boss/groupTeam',
        method: 'delete'
    },
    groupTeamInfo: { // 获取分组信息详情
        url: 'boss/groupTeam',
        method: 'get'
    },
    groupTeamUpdate: { // 更新分组信息
        url: 'boss/groupTeam',
        method: 'put'
    },
    groupTeamStudent: { // 获取分组下所有学生
        url: 'boss/groupTeam/getGroupTeamStudent',
        method: 'get'
    },
    getTeamSchoolStudent: { // 获取能够加入分组的学生列表
        url: 'boss/groupTeam/getTeamSchoolStudent',
        method: 'get'
    },
    addGroupTeamStudent: { // 添加分组学生
        url: 'boss/groupTeam/addGroupTeamStudent',
        method: 'post'
    },
    delGroupTeamStudent: { // 删除分组学生
        url: 'boss/groupTeam/delGroupTeamStudent',
        method: 'post'
    },
    groupTeamTimeTableIndex: { // 获取分组的课表信息列表
        url: 'boss/groupTeam/groupTeamTimeTableIndex',
        method: 'get'
    },
    addGroupTimeTable: { // 新增分组排课保存
        url: 'boss/groupTeam/addGroupTimeTable',
        method: 'post'
    },
    delGroupTimeTable: { // 删除分组排课
        url: 'boss/groupTeam/delGroupTimeTable',
        method: 'post'
    },
    showGroupTimeTable:{//获取分组排课表中的详细信息
        url: 'boss/groupTeam/getGroupTimeTableShow',
        method: 'get'
    },
    getGroupTimeTableStudent:{//获取分组排课下的所以学生
        url: 'boss/groupTeam/getGroupTimeTableStudent',
        method: 'get'
    },
    /* 2.1.6 */
    studentRechargeOrderList: { // 某学生校区的充值订单列表
        url: 'boss/rechargeOrder/studentRechargeOrderList',
        method: 'get'
    },
    studentProductOrderList: { // 学生购买产品记录
        url: 'boss/productOrder/studentProductOrderList',
        method: 'get'
    },

    getStudentSubjectGuide: { // ITS学生学科导图
        url: 'boss/student/getStudentSubjectGuide',
        method: 'get'
    },
    getStudentSubjectGuideExceExport: { // ITS学生学科导图导出excel
        url: 'boss/student/getStudentSubjectGuideExceExport',
        method: 'get'
    },
    getStudentSubjectGuideReportDown: { // IITS学生学科导图报告单个下载
        url: 'boss/student/getStudentSubjectGuideReportDown',
        method: 'get'
    },
    getStudentSubjectGuideReportPackDown: { // ITS学生学科导图报告打包下载
        url: 'boss/student/getStudentSubjectGuideReportPackDown',
        method: 'get'
    },

    lessonList: { // 216精雕细课学习数据-讲次列表
        url: 'jdxk/jdxk/lesson/list',
        method: 'get'
    },
    studyList: { // 精雕细课学习数据
        url: 'jdxk/jdxk/students/push/list',
        method: 'get'
    },
    studyjdxkList: { // 精雕细课学习数据
        url: 'jdxk/jdxk/study/list',
        method: 'get'
    },
    studyListExport: { // 精雕细课学习数据导出
        url: 'jdxk/jdxk/study/list/export',
        method: 'get'
    },
    studentsPushListExport: { // 精雕细课学情信息 - 导出
        url: 'jdxk/jdxk/students/push/list/export',
        method: 'get'
    },

    getStudentWrongQuestion: { // ITS学生错题本
        url: 'boss/student/getStudentWrongQuestion',
        method: 'get'
    },
    getStudentWrongQuestionExport: { // ITS学生错题本导出word
        url: 'boss/student/getStudentWrongQuestionExport',
        method: 'get'
    },

    getStudentReportList: { // ITS学生学习报告列表
        url: 'boss/student/getStudentReportList',
        method: 'get'
    },
    getStudentReportPackageDown: { // ITS学生学习报告打包下载发邮件
        url: 'boss/student/getStudentReportPackageDown',
        method: 'get'
    },
    getStudentReportDown: { // ITS学生学习报告下载
        url: 'boss/student/getStudentReportDown',
        method: 'get'
    },

    getStudentClassList: { // 获取单个学生所有班级列表
        url: 'boss/classTeam/getStudentClassList',
        method: 'get'
    },
    getStudentClassTimeTableFeedback: { // ITS学生课程信息反馈
        url: 'boss/classTeam/getStudentClassTimeTableFeedback',
        method: 'get'
    },
    studentClassTimeTableExport: { // ITS学生课程信息导出
        url: 'boss/classTeam/studentClassTimeTableExport',
        method: 'get'
    },
    /* 2.1.2 */
    assignmentJson:{ //批量分配校区
        url: 'crm/customerSchool/assignmentJson',
        method: 'post'
    },
    getSigningPageList:{ //预收金额列表
        url: 'crm/signingPlan/getSigningPageList',
        method: 'get'
    },
    /* adminUpdCustomerInfo:{ //修改已签约的客户信息
        url: 'crm/customer/adminUpdCustomerInfo',
        method: 'post'
    }, */
    /* 2.2.4 */
    achievementSubject:{ //成绩科目-列表
        url: 'pub/achievementSubject',
        method: 'get'
    },
    postAchievementSubject:{ //成绩科目-添加
        url: 'pub/achievementSubject',
        method: 'post'
    },
    achievementSubjectInfo:{ //成绩科目-详情
        url: 'pub/achievementSubject',
        method: 'get'
    },
    putAchievementSubject:{ //成绩科目-更新
        url: 'pub/achievementSubject',
        method: 'put'
    },
    achievementSubjectStatus:{ //成绩科目-启用禁用
        url: 'pub/achievementSubject/status',
        method: 'get'
    },
    achievementList:{ //成绩管理列表
        url: 'boss/achievement',
        method: 'get'
    },
    achievementId:{ ///{id}成绩单条
        url: 'boss/achievement',
        method: 'get'
    },
    putAchievementId:{ ///修改成绩单条
        url: 'boss/achievement',
        method: 'put'
    },
    deleteAchievementId:{ ///{id}删除单条成绩
        url: 'boss/achievement',
        method: 'delete'
    },
    achievementOrdinary: { //普通成绩录入
        url: 'boss/achievement/ordinary',
        method: 'post'
    },
    achievementMiddle: { //中考成绩录入
        url: 'boss/achievement/middle',
        method: 'post'
    },
    achievementHigh: { //高考成绩录入
        url: 'boss/achievement/high',
        method: 'post'
    },
    resultStudentList:{ //成绩管理-学生列表
        url: 'boss/student/resultStudentList',
        method: 'get'
    },
    getAchievementByStudent:{ //成绩管理--获取单个学生所有的成绩
        url: 'boss/achievement/getAchievementByStudent',
        method: 'get'
    },
    getAchievementExport:{ //成绩管理导出
        url: 'boss/achievement/export',
        method: 'get'
    },
    /* 2.2.8 */
    checkJoinClassTeam:{ //校验可以加入的班组
        url: 'team/classTeam/checkJoinClassTeam',
        method: 'post'
    },
    getFineLesson: { //获取精雕细课学生表
        url: 'boss/studentProductCycle/getFineLesson',
        method: 'get'
    },
    getFineLessonDetails: { //精雕细课-课表-查看
        url: 'jdxk/boss/timetables/details',
        method: 'get'
    },
    studentPush: { //学生推送计划
        url: 'jdxk/boss/students/push',
        method: 'get'
    },
    getApprovalPersonList: { //获取审批节点的人员信息
        url: 'boss/approvalFlow/getApprovalPersonList',
        method: 'get'
    },
    /* 2.3.0 */
    studentAutomaticIncomeList: {
        url: 'boss/automaticIncome/studentAutomaticIncomeList',
        method: 'get'
    },
    workerNewList: {
        url: 'ums/workers/newList',
        method: 'get'
    },
    departmentSort: {
        url: 'pub/department/setSort',
        method: 'put'
    },
    voidEndClass: {
        url: 'boss/classTeam/voidEndClass',
        method: 'get'
    },
    voidEndClassSuper: {
        url: 'boss/superClass/voidEndClass',
        method: 'get'
    },
    clearNotReadMessage: {
        url: 'pub/messageLog/clearNotReadMessage',
        method: 'get'
    },
    /* 2.3.5 */
    departmentLogo: {
        url: 'pub/departmentLogo',// 获取全部企业logo信息列表
        method: 'get'
    },
    departmentLogoPost: {
        url: 'pub/departmentLogo',// 获取全部企业logo信息新增
        method: 'post'
    },
    departmentLogoInfo: {
        url: 'pub/departmentLogo',// 获取全部企业logo信息详情
        method: 'get'
    },
    departmentLogoUpdate: {
        url: 'pub/departmentLogo',// 获取全部企业logo信息修改
        method: 'put'
    },
    departmentLogoStatus: {
        url: 'pub/departmentLogo/setStatus',// 企业logo信息停用/启用
        method: 'post'
    },
    cancelSystem: {
        url: 'boss/approvalFlow/cancelSystem',// 管理员撤销审批接口
        method: 'put'
    },
    /* 2.3.6 */
    classOpenLog: {
        url: 'boss/classTeam/classOpenLog',// 获取班级开班日志信息列表
        method: 'get'
    },
    classOpenLogExport: {
        url: 'boss/classTeam/classOpenLogExport',// 获取班级开班日志信息列表导出
        method: 'get'
    },
    /* 2.3.8 */
    getStudentWrongQuestionForEmail: { // ITS学生错题本导出图片
        url: 'boss/student/getStudentWrongQuestionForEmail',
        method: 'get'
    },
    studentSchoolProductType: { // 获取学生报名校区 状态 以及产品类型状态[学生详情中展示]
        url: 'boss/studentStatus/schoolProductType',
        method: 'get'
    },
    getStudentSchoolProductType: { // 手动修改学生页面获取当前产品类型状态
        url: 'boss/studentStatus/productType',
        method: 'get'
    },
    manualModify: { //  手动修改学生状态
        url: 'boss/studentStatus/manualModify',
        method: 'post'
    },
    changeRecord: { //  获取学生状态日志列表
        url: 'boss/studentStatus/changeRecord',
        method: 'get'
    },
    manualConsume: { //  手动消耗余额
        url: 'boss/studentStatus/manualConsume',
        method: 'post'
    },
    /* 2.3.9 */
    createFileSend: {// 建档发送短信验证码
        url: 'pub/smsLog/createFileSend',
        method: 'post'
    },
    createFileVerify: {// 建档发送短信验证码
        url: 'pub/smsLog/createFileVerify',
        method: 'post'
    },
    sendSignatureMessagePro: {// 产品订单推送待签字合同信息
        url: 'boss/productOrder/sendSignatureMessagePro',
        method: 'post'
    },
    sendSignatureMessageOff: {// 产品订单签字推送消息
        url: 'boss/productOrder/sendSignatureMessage',
        method: 'post'
    },
    sendSignatureMessage: {// 充值订单签字推送消息
        url: 'boss/rechargeOrder/sendSignatureMessage',
        method: 'post'
    },
    /* 2.4.0 */
    adminUpdCustomerInfo:{ // 修改已签约的客户信息
        url: 'crm/customer/adminUpdCustomerInfo',
        method: 'post'
    },
    updateCreateEid:{ // 修改学生绑定，并新增EID
        url: 'boss/student/updateCreateEid',
        method: 'post'
    },
    superClassStudentClassSignSendMail:{ // 超级班-学生课签记录导出
        url: 'boss/sign/superClassStudentClassSignSendMail',
        method: 'post'
    },
    superClassTeacherClassSignSendMail:{ // 超级班-老师课签记录导出
        url: 'boss/sign/superClassTeacherClassSignSendMail',
        method: 'post'
    },
    detailStudentAnswer:{ // 获取作业题目内容以及学生答案
        url: 'jdxk/jdxk/task/detailStudentAnswer',
        method: 'get'
    },
    getSchoolAllFixedTimeTable:{ // 获取可复制的课表数据
        url: 'boss/timeTable/getSchoolAllFixedTimeTable',
        method: 'get'
    },
    getReplicateTimeTableLog:{ // 获取某个校区，复制课表操作日志
        url: 'boss/timeTable/getReplicateTimeTableLog',
        method: 'get'
    },
    getReplicateTimeTableLogDetails:{ // 获取某个复制课表操作日志的详情
        url: 'boss/timeTable/getReplicateTimeTableLogDetails',
        method: 'get'
    },
    setReplicateTimeTable:{ // 提交复制课表
        url: 'boss/timeTable/setReplicateTimeTable',
        method: 'post'
    },
    getReplicateTimeTableLogDetailsExport:{ // 课表日志导出
        url: 'boss/timeTable/getReplicateTimeTableLogDetailsExport',
        method: 'get'
    },
    /* 2.4.2 */
    changeRecordExport:{ // 课表日志导出
        url: 'boss/studentStatus/changeRecordExport',
        method: 'get'
    },
    /* crm3.0 */
    customerGetListPage:{ // 列表
        url: 'crm/customerSchool/getListPage',
        method: 'get'
    },
    updCustomerInfo:{ // 修改客户任意字段
        url: 'crm/customer/updCustomerInfo',
        method: 'post'
    },
    updCustomerTags:{ // 修改客户标签
        url: 'crm/customer/updCustomerTags',
        method: 'post'
    },
    getCustomerInfo:{ // 获取客户信息（渠道信息，校区信息等）
        url: 'crm/customer/getCustomerInfo',
        method: 'get'
    },
    updSchoolCrmType:{ // 修改校区客户等级
        url: 'crm/customerSchool/updSchoolCrmType',
        method: 'post'
    },
    updCustomerInfoAndChannelAndSchoolAndAttached:{ // 详情修改客户资料(包括，渠道资料，校区资料)
        url: 'crm/customer/updCustomerInfoAndChannelAndSchoolAndAttached',
        method: 'post'
    },
    returnVisitReminder:{ // 提醒回访添加
        url: 'crm/returnVisitReminder',
        method: 'post'
    },
    returnVisitReminderList:{ // 提醒回访列表
        url: 'crm/returnVisitReminder',
        method: 'get'
    },
    reminderDateStatistics:{ // 提醒回访时间段统计
        url: 'crm/returnVisitReminder/dateStatistics',
        method: 'get'
    },
    reminerOperation:{ // 提醒回访操作
        url: 'crm/returnVisitReminder/reminerOperation',
        method: 'post'
    },
    voidCustomer:{ // 标记无效客户
        url: 'crm/customerSchool/voidCustomer',
        method: 'post'
    },
    invalidationReasonList:{ // 获取全部无效原因信息
        url: 'pub/invalidationReason',
        method: 'get'
    },
    invalidationReasonAdd:{ // 创建新的无效原因信息
        url: 'pub/invalidationReason',
        method: 'post'
    },
    invalidationReasonUpdate:{ // 更新无效原因信息
        url: 'pub/invalidationReason',
        method: 'put'
    },
    invalidationReasonStatus:{ // 停用启用
        url: 'pub/invalidationReason',
        method: 'delete'
    },
    invalidationReasonSelect:{ // 下拉获取无效原因信息
        url: 'pub/invalidationReason/ajaxInvalidationReason',
        method: 'get'
    },
    schoolCustomerStatusLog:{ // 客户状态日志列表
        url: 'crm/schoolCustomerStatusLog',
        method: 'get'
    },
    /* 2.4.5 */
    statisticsCustomerSchoolStatus:{ // 校区各客户阶段数量统计
        url: 'crm/customerSchool/statisticsCustomerSchoolStatus',
        method: 'get'
    },
    returnVisitReminderDel:{ // 删除提醒回访
        url: 'crm/returnVisitReminder',
        method: 'delete'
    },
    getAchievementUpdateTeacherList:{ // 得到对应的成绩录入的学生对应科目的老师信息
        url: 'boss/achievement/getAchievementUpdateTeacherList',
        method: 'get'
    },
    updateAchievementTeacher:{ // 修改成绩对应科目老师
        url: 'boss/achievement/updateAchievementTeacher',
        method: 'post'
    },
    getAchievementStatisticslist:{ // 成绩统计列表
        url: 'boss/achievement/getAchievementStatisticslist',
        method: 'get'
    },
    getStatisticsUpdateTeacherList:{ // 成绩统计录入的学生对应科目的老师信息
        url: 'boss/achievement/getStatisticsUpdateTeacherList',
        method: 'get'
    },
    updateAchievementStatisticsTeacher:{ // 修改成绩统计对应科目老师
        url: 'boss/achievement/updateAchievementStatisticsTeacher',
        method: 'post'
    },
    exportStatistics:{ // 成绩统计导出
        url: 'boss/achievement/exportStatistics',
        method: 'get'
    },
    /* 2.4.6 */
    customerReturnVisitList:{ // 客户的全部回访记录
        url: 'crm/customer/customerReturnVisitList',
        method: 'get'
    },
    getDepWorkersPage:{ // 获取部门下所有员工带分页
        url: 'ums/workers/getDepWorkersPage',
        method: 'get'
    },
    batchStoreReminerJson:{ // 批量分配客户回访提醒
        url: 'crm/returnVisitReminder/batchStoreReminerJson',
        method: 'post'
    },
    itsSuggestions:{ // 家长端投诉建议的列表
        url: 'boss/itsSuggestions',
        method: 'get'
    },
    itsSuggestionsInfo:{ // 家长端投诉建议的详情
        url: 'boss/itsSuggestions',
        method: 'get'
    },
    itsSuggestionsEdit:{ // 家长端投诉建议编辑
        url: 'boss/itsSuggestions',
        method: 'put'
    },
    /* 2.4.7 */
    statisticsCustomerChannelStatus:{ // 渠道各客户阶段数量统计
        url: 'crm/customerChannel/statisticsCustomerSchoolStatus',
        method: 'get'
    },
    fastStore:{ // 快速新增
        url: 'crm/customerChannel/fastStore',
        method: 'post'
    },
    getComeToDoorCustomerInfo:{ // 上门登记手机号查客户
        url: 'crm/customer/getComeToDoorCustomerInfo',
        method: 'get'
    },
    buyTransferProductOrder:{ // 转介绍赠送产品购买
        url: 'boss/productOrder/buyTransferProductOrder',
        method: 'post'
    },
    getTransferProductByOrder:{ // 转介绍购买产品时根据产品类型和校区获取可购买产品的列表
        url: 'boss/product/getTransferProductByOrder',
        method: 'get'
    },
    getStudentAllSchoolAndTransfer:{ // 获取学生所有校区，以及转介绍金额
        url: 'boss/student/getStudentAllSchoolAndTransfer',
        method: 'get'
    },
}

export { model, config }



// WEBPACK FOOTER //
// ./src/service/model.js